import WindowInterface from "Interfaces/WindowInterface"

declare const window: WindowInterface

import LocalizedString from "Models/LocalizedString"
import RequestBuilder from "Models/RequestBuilder"

export default class Language {

  public langcode
  public label
  public strings

  constructor(jsonApiDocument: any) {
    this.langcode = jsonApiDocument.attributes.drupal_internal__id
    this.label = jsonApiDocument.attributes.label
  }

  async load() {
    if(!this.strings) {
      this.strings = []

      /*
      let result = await window.api.get(new RequestBuilder()
        .langcode(this.langcode)
        .resource('a/utils/strings')
        .build()
      )
      for(const row of result.data.data) {
        this.strings.push(new LocalizedString(row))
      }
      */
     
      let stringResults = {
          "status": "success",
          "data": [
              {
                  "source": "app-results-headline",
                  "translation": "Hi ${firstName}!"
              },
              {
                  "source": "app-results-subheadline",
                  "translation": "There are ${count} programs matching your criteria within ${distance} miles."
              },
              {
                  "source": "app-results-subheadline-singular",
                  "translation": "There is ${count} program matching your criteria within ${distance} miles."
              },
              {
                  "source": "app-apply-subheadline",
                  "translation": "Apply to ${title}."
              },
              {
                  "source": "app-application-submitted-headline",
                  "translation": "Hello ${test}"
              },
              {
                  "source": "app-english",
                  "translation": "English"
              },
              {
                  "source": "app-spanish",
                  "translation": "Spanish"
              },
              {
                  "source": "app-add-organization",
                  "translation": "Submit Organization"
              },
              {
                  "source": "app-organization-name",
                  "translation": "Organization Name"
              },
              {
                  "source": "app-organization-legal-name",
                  "translation": "Legal Name"
              },
              {
                  "source": "app-organization-description",
                  "translation": "Description of Organization"
              },
              {
                  "source": "app-organization-submitted-headline",
                  "translation": "Congratulations!"
              },
              {
                  "source": "app-submit-organization",
                  "translation": "Submit Organization"
              },
              {
                  "source": "app-type",
                  "translation": "Type"
              },
              {
                  "source": "app-scope",
                  "translation": "Scope"
              },
              {
                  "source": "app-focus",
                  "translation": "Focus"
              },
              {
                  "source": "app-organization-type-government",
                  "translation": "Government"
              },
              {
                  "source": "app-organization-type-business",
                  "translation": "Business"
              },
              {
                  "source": "app-organization-type-agency",
                  "translation": "Agency"
              },
              {
                  "source": "app-organization-type-community",
                  "translation": "Community"
              },
              {
                  "source": "app-organization-type-faith-based",
                  "translation": "Faith Based"
              },
              {
                  "source": "app-organization-scope-national",
                  "translation": "National"
              },
              {
                  "source": "app-organization-scope-regional",
                  "translation": "Regional"
              },
              {
                  "source": "app-organization-scope-local",
                  "translation": "Local"
              },
              {
                  "source": "app-organization-focus-research",
                  "translation": "Research"
              },
              {
                  "source": "app-organization-focus-community-investment",
                  "translation": "Community Investment"
              },
              {
                  "source": "app-organization-focus-social-development",
                  "translation": "Social Development"
              },
              {
                  "source": "app-organization-focus-youth-advocacy",
                  "translation": "Youth Advocacy"
              },
              {
                  "source": "app-organization-focus-youth-development",
                  "translation": "Youth Development"
              },
              {
                  "source": "app-organization-focus-youth-health",
                  "translation": "Health & Wellness"
              },
              {
                  "source": "app-organization-focus-development",
                  "translation": "Youth Development"
              },
              {
                  "source": "app-organization-focus-health",
                  "translation": "Health & Wellness"
              },
              {
                  "source": "app-submit",
                  "translation": "Submit"
              },
              {
                  "source": "app-organization-basic-information",
                  "translation": "Basic Information"
              },
              {
                  "source": "app-organization-additional-information",
                  "translation": "Additional Information"
              },
              {
                  "source": "app-organization-annual-budget",
                  "translation": "Annual Budget"
              },
              {
                  "source": "app-organization-accreditation",
                  "translation": "Accreditation"
              },
              {
                  "source": "app-organization-tax-status",
                  "translation": "Tax Status"
              },
              {
                  "source": "app-organization-funding",
                  "translation": "Funding"
              },
              {
                  "source": "app-organization-private",
                  "translation": "Private"
              },
              {
                  "source": "app-organization-public",
                  "translation": "Public"
              },
              {
                  "source": "app-organization-date-established",
                  "translation": "Date Established"
              },
              {
                  "source": "app-contact-alternate-phone",
                  "translation": "Alternate Phone"
              },
              {
                  "source": "app-contact-phone",
                  "translation": "Phone"
              },
              {
                  "source": "app-contact-position",
                  "translation": "Position"
              },
              {
                  "source": "app-first-name",
                  "translation": "First Name"
              },
              {
                  "source": "app-last-name",
                  "translation": "Last Name"
              },
              {
                  "source": "app-organization-contact",
                  "translation": "Organization Contact Information"
              },
              {
                  "source": "app-email",
                  "translation": "Email"
              },
              {
                  "source": "app-organization-submitted-subtitle",
                  "translation": "The organization '${organizationName}' has been submitted for review."
              },
              {
                  "source": "app-address",
                  "translation": "Address"
              },
              {
                  "source": "app-web-address",
                  "translation": "Web Address"
              },
              {
                  "source": "app-availability",
                  "translation": "Availability"
              },
              {
                  "source": "app-from",
                  "translation": "From"
              },
              {
                  "source": "app-to",
                  "translation": "To"
              },
              {
                  "source": "app-monday",
                  "translation": "Monday"
              },
              {
                  "source": "app-tuesday",
                  "translation": "Tuesday"
              },
              {
                  "source": "app-wednesday",
                  "translation": "Wednesday"
              },
              {
                  "source": "app-thursday",
                  "translation": "Thursday"
              },
              {
                  "source": "app-friday",
                  "translation": "Friday"
              },
              {
                  "source": "app-saturday",
                  "translation": "Saturday"
              },
              {
                  "source": "app-sunday",
                  "translation": "Sunday"
              },
              {
                  "source": "app-parent-organization",
                  "translation": "Parent Organization"
              },
              {
                  "source": "app-sign-in",
                  "translation": "Sign In"
              },
              {
                  "source": "app-forgot-password",
                  "translation": "Forgot your password?"
              },
              {
                  "source": "app-forgot",
                  "translation": "Get New Password"
              },
              {
                  "source": "app-forgot-description",
                  "translation": "Please enter your email address. You will receive a link to create a new password via email."
              },
              {
                  "source": "app-email-reset-password-header",
                  "translation": "Reset Password"
              },
              {
                  "source": "app-email-reset-password-paragraph-1",
                  "translation": "Someone has requested a password reset for your Mentoring Connector account."
              },
              {
                  "source": "app-email-reset-password-paragraph-2",
                  "translation": "If this was a mistake, just ignore this email and nothing will happen."
              },
              {
                  "source": "app-email-reset-password-paragraph-3",
                  "translation": "To reset your password, click the following link."
              },
              {
                  "source": "app-email-reset-password-link",
                  "translation": "Reset your password"
              },
              {
                  "source": "app-checkemail",
                  "translation": "Check your email for the password reset link."
              },
              {
                  "source": "app-reset",
                  "translation": "Reset Password"
              },
              {
                  "source": "app-new-password",
                  "translation": "New Password"
              },
              {
                  "source": "app-new-password-confirm",
                  "translation": "Confirm New Password"
              },
              {
                  "source": "app-password-must-match",
                  "translation": "The passwords entered do not match"
              },
              {
                  "source": "app-organization-submitted-paragraph",
                  "translation": "We'll follow-up with you shortly by email at ${email}. Thank you for supporting mentoring in your community."
              },
              {
                  "source": "app-organizations",
                  "translation": "Organizations"
              },
              {
                  "source": "app-table-edit",
                  "translation": "View and edit"
              },
              {
                  "source": "app-table-admin",
                  "translation": "Administration"
              },
              {
                  "source": "app-admin-add-organization",
                  "translation": "Add an organization"
              },
              {
                  "source": "app-table-organization-empty",
                  "translation": "No Organizations Found"
              },
              {
                  "source": "app-table-export",
                  "translation": "Export this table"
              },
              {
                  "source": "app-admin-add-program",
                  "translation": "Add a program"
              },
              {
                  "source": "app-admin-add-region",
                  "translation": "Add a region"
              },
              {
                  "source": "app-admin-add-country",
                  "translation": "Add a country"
              },
              {
                  "source": "app-admin-add-account",
                  "translation": "Add an account"
              },
              {
                  "source": "app-searches",
                  "translation": "Searches"
              },
              {
                  "source": "app-applications",
                  "translation": "Applications"
              },
              {
                  "source": "app-programs",
                  "translation": "Programs"
              },
              {
                  "source": "app-regions",
                  "translation": "Affiliates"
              },
              {
                  "source": "app-countries",
                  "translation": "Countries"
              },
              {
                  "source": "app-accounts",
                  "translation": "Accounts"
              },
              {
                  "source": "app-start-date",
                  "translation": "From"
              },
              {
                  "source": "app-end-date",
                  "translation": "To"
              },
              {
                  "source": "app-filter-standing",
                  "translation": "Standing"
              },
              {
                  "source": "app-table-search-empty",
                  "translation": "No Searches Found"
              },
              {
                  "source": "app-table-application-empty",
                  "translation": "No Applications Found"
              },
              {
                  "source": "app-table-program-empty",
                  "translation": "No Programs Found"
              },
              {
                  "source": "app-table-region-empty",
                  "translation": "No Regions Found"
              },
              {
                  "source": "app-table-country-empty",
                  "translation": "No Countries Found"
              },
              {
                  "source": "app-table-account-empty",
                  "translation": "No Accounts Found"
              },
              {
                  "source": "app-email-organization-submited-receipt",
                  "translation": "Organization Submitted"
              },
              {
                  "source": "app-email-organization-submitted-paragraph-1",
                  "translation": "Thank you for submitting the '@organizationName' organization to the Mentoring Connector."
              },
              {
                  "source": "app-email-organization-admin-notification-paragraph-1",
                  "translation": "@firstName @lastName has submitted the organization '@organizationName' for review."
              },
              {
                  "source": "app-organization-settings-approval",
                  "translation": "Approval of the '${organizationName}' Organization"
              },
              {
                  "source": "app-approval",
                  "translation": "Your approval of the organization"
              },
              {
                  "source": "app-administrators",
                  "translation": "Administrators"
              },
              {
                  "source": "app-organization-settings",
                  "translation": "Organization Settings"
              },
              {
                  "source": "app-organization-settings-description",
                  "translation": "Review how other administrators have approved of this organization in the table below, and indicate your own approval. Organizations are approved if any administrator has indicated their approval, and disapproved if any administrator has selected to deny. Select 'Pending' to indicate that you are considering their status. You may clear your selection if you do not wish to weigh in on this organization's status."
              },
              {
                  "source": "app-neutral",
                  "translation": "No opinion"
              },
              {
                  "source": "app-allowed",
                  "translation": "Approved"
              },
              {
                  "source": "app-denied",
                  "translation": "Denied"
              },
              {
                  "source": "app-search",
                  "translation": "Search"
              },
              {
                  "source": "app-add-program",
                  "translation": "Add Program"
              },
              {
                  "source": "app-admin",
                  "translation": "Admin"
              },
              {
                  "source": "app-email-salutation",
                  "translation": "Dear @firstName,"
              },
              {
                  "source": "app-email-organization-submitted-paragraph-2",
                  "translation": "The organization's application is under review."
              },
              {
                  "source": "app-email-organization-submitted-paragraph-3",
                  "translation": "We'll follow-up with you shortly. Thank you for supporting mentoring in your community."
              },
              {
                  "source": "app-email-organization-admin-notification-paragraph-2",
                  "translation": "To review the organization, click the following link."
              },
              {
                  "source": "app-email-organization-admin-notification-link",
                  "translation": "Review the organization"
              },
              {
                  "source": "app-delete",
                  "translation": "Delete"
              },
              {
                  "source": "app-partner-name",
                  "translation": "Name"
              },
              {
                  "source": "app-partner-id",
                  "translation": "Partner ID"
              },
              {
                  "source": "app-partners",
                  "translation": "Partners"
              },
              {
                  "source": "app-program-basic-information",
                  "translation": "Basic Information"
              },
              {
                  "source": "app-program-name",
                  "translation": "Program Name"
              },
              {
                  "source": "app-french",
                  "translation": "French"
              },
              {
                  "source": "app-program-description",
                  "translation": "Program Description"
              },
              {
                  "source": "app-program-external-id",
                  "translation": "External ID"
              },
              {
                  "source": "app-program-employer-id",
                  "translation": "Employer ID Number"
              },
              {
                  "source": "app-organization",
                  "translation": "Organization"
              },
              {
                  "source": "app-form",
                  "translation": "Form"
              },
              {
                  "source": "app-type-of-mentoring-1-to-1",
                  "translation": "1:1 (One-to-One)"
              },
              {
                  "source": "app-type-of-mentoring-group",
                  "translation": "Group"
              },
              {
                  "source": "app-type-of-mentoring-team",
                  "translation": "Team"
              },
              {
                  "source": "app-type-of-mentoring-e-mentoring",
                  "translation": "E-Mentoring / Virtual Mentoring"
              },
              {
                  "source": "app-type-of-mentoring-peer",
                  "translation": "Peer"
              },
              {
                  "source": "app-type-of-mentoring-school",
                  "translation": "School-based 1:1"
              },
              {
                  "source": "app-other",
                  "translation": "Other"
              },
              {
                  "source": "app-yes",
                  "translation": "Yes"
              },
              {
                  "source": "app-no",
                  "translation": "No"
              },
              {
                  "source": "app-not-applicable",
                  "translation": "Not applicable"
              },
              {
                  "source": "app-approved",
                  "translation": "Approved"
              },
              {
                  "source": "app-unapproved",
                  "translation": "Unapproved"
              },
              {
                  "source": "app-set-by-participants",
                  "translation": "Set by participants"
              },
              {
                  "source": "app-set-by-admin",
                  "translation": "Set by program"
              },
              {
                  "source": "app-months-1-2",
                  "translation": "1 to 2 months"
              },
              {
                  "source": "app-months-3",
                  "translation": "3 months"
              },
              {
                  "source": "app-months-4",
                  "translation": "4 months"
              },
              {
                  "source": "app-months-5",
                  "translation": "5 months"
              },
              {
                  "source": "app-months-6",
                  "translation": "6 months"
              },
              {
                  "source": "app-months-7",
                  "translation": "7 months"
              },
              {
                  "source": "app-months-8",
                  "translation": "8 months"
              },
              {
                  "source": "app-months-9",
                  "translation": "9 months"
              },
              {
                  "source": "app-months-10",
                  "translation": "10 months"
              },
              {
                  "source": "app-months-11",
                  "translation": "11 months"
              },
              {
                  "source": "app-months-12-or-longer",
                  "translation": "12 months or longer"
              },
              {
                  "source": "app-months-no-minimum",
                  "translation": "No minimum (commitment is required but the duration is flexible)"
              },
              {
                  "source": "app-months-no-requirement",
                  "translation": "No requirement"
              },
              {
                  "source": "app-frequency-weekly",
                  "translation": "Weekly"
              },
              {
                  "source": "app-frequency-bi-weekly",
                  "translation": "Bi-weekly"
              },
              {
                  "source": "app-frequency-monthly",
                  "translation": "Monthly"
              },
              {
                  "source": "app-frequency-no-requirement",
                  "translation": "No requirement"
              },
              {
                  "source": "app-hours-per-week-1",
                  "translation": "1 hour"
              },
              {
                  "source": "app-hours-per-week-2-3",
                  "translation": "2 to 3 hours"
              },
              {
                  "source": "app-hours-per-week-3-4",
                  "translation": "3 to 4 hours"
              },
              {
                  "source": "app-hours-per-week-4-5",
                  "translation": "4 to 5 hours"
              },
              {
                  "source": "app-hours-per-week-5-or-more",
                  "translation": "5 hours or more"
              },
              {
                  "source": "app-hours-per-week-no-requirement",
                  "translation": "No requirement"
              },
              {
                  "source": "app-mentors-must-complete-an-application",
                  "translation": "Mentors must complete an application"
              },
              {
                  "source": "app-mentors-must-provide-references",
                  "translation": "Mentors must provide references"
              },
              {
                  "source": "app-mentors-must-provide-a-criminal-background-check",
                  "translation": "Mentors must provide a criminal background check"
              },
              {
                  "source": "app-mentors-must-provide-a-vulnerable-sector-check",
                  "translation": "Mentors must provide a vulnerable sector check"
              },
              {
                  "source": "app-mentors-must-provide-a-child-and-family-services-background-check",
                  "translation": "Mentors must provide a child and family services background check"
              },
              {
                  "source": "app-mentors-must-attend-an-interview-with-program-staff",
                  "translation": "Mentors must attend an interview with program staff"
              },
              {
                  "source": "app-mentees-must-complete-an-application",
                  "translation": "Mentees must complete an application"
              },
              {
                  "source": "app-mentees-must-be-referred-to-the-program",
                  "translation": "Mentees must be referred to the program"
              },
              {
                  "source": "app-mentees-must-attend-an-interview-with-program-staff",
                  "translation": "Mentees must attend an interview with program staff"
              },
              {
                  "source": "app-in-person",
                  "translation": "In person"
              },
              {
                  "source": "app-online-virtual",
                  "translation": "Online / virtual"
              },
              {
                  "source": "app-hardcopy-manual",
                  "translation": "Hardcopy manual"
              },
              {
                  "source": "app-manual-matching-by-program-staff",
                  "translation": "Manual matching by program staff"
              },
              {
                  "source": "app-manual-matching-by-school-or-third-party",
                  "translation": "Manual matching by school or third party"
              },
              {
                  "source": "app-random-matching",
                  "translation": "Random matching"
              },
              {
                  "source": "app-youth-initiated-mentoring",
                  "translation": "Youth-initiated mentoring (i.e. mentee chooses the mentor)"
              },
              {
                  "source": "app-technologically-assisted-matching",
                  "translation": "Technologically assisted matching (e.g. guided by an algorithm, formula, or rubric)"
              },
              {
                  "source": "app-no-formal-matching",
                  "translation": "No formal matching"
              },
              {
                  "source": "app-ca-program-focus-academics-literacy",
                  "translation": "Academics / literacy"
              },
              {
                  "source": "app-ca-program-focus-arts",
                  "translation": "Arts"
              },
              {
                  "source": "app-ca-program-focus-job-skills-career-readiness",
                  "translation": "Job skills / career readiness"
              },
              {
                  "source": "app-ca-program-focus-sports-activities",
                  "translation": "Sports / activities"
              },
              {
                  "source": "app-ca-program-focus-stem",
                  "translation": "STEM"
              },
              {
                  "source": "app-ca-program-focus-social-emotional-skills",
                  "translation": "Social emotional skills"
              },
              {
                  "source": "app-ca-program-focus-community-connections-building-social-capital",
                  "translation": "Community connections / building social capital"
              },
              {
                  "source": "app-ca-program-focus-health-and-well-being",
                  "translation": "Health and well-being (incl. mental health)"
              },
              {
                  "source": "app-ca-program-focus-faith",
                  "translation": "Faith"
              },
              {
                  "source": "app-ca-program-focus-culture",
                  "translation": "Culture"
              },
              {
                  "source": "app-us-program-focus-academics",
                  "translation": "Academics / Literacy"
              },
              {
                  "source": "app-us-program-focus-arts",
                  "translation": "Arts"
              },
              {
                  "source": "app-us-program-focus-job-skills",
                  "translation": "Job skills"
              },
              {
                  "source": "app-us-program-focus-job-sports",
                  "translation": "Sports"
              },
              {
                  "source": "app-us-program-focus-job-stem",
                  "translation": "STEM"
              },
              {
                  "source": "app-ca-program-meeting-program-agency-site",
                  "translation": "Program / Agency Site"
              },
              {
                  "source": "app-ca-program-meeting-community",
                  "translation": "Community"
              },
              {
                  "source": "app-ca-program-meeting-faith-based-site",
                  "translation": "Faith-based site"
              },
              {
                  "source": "app-ca-program-meeting-youth-custody-correctional-facility",
                  "translation": "Youth custody / correctional facility"
              },
              {
                  "source": "app-ca-program-meeting-mental-health-treatment-facility",
                  "translation": "Mental health / treatment facility"
              },
              {
                  "source": "app-ca-program-meeting-school-academic-site",
                  "translation": "School / Academic site"
              },
              {
                  "source": "app-ca-program-meeting-workplace",
                  "translation": "Workplace"
              },
              {
                  "source": "app-ca-program-meeting-after-school-site",
                  "translation": "After school site"
              },
              {
                  "source": "app-ca-program-meeting-online-virtual",
                  "translation": "Online / virtual"
              },
              {
                  "source": "app-us-program-meeting-agency",
                  "translation": "Agency site"
              },
              {
                  "source": "app-us-program-meeting-community",
                  "translation": "Community"
              },
              {
                  "source": "app-us-program-meeting-faith",
                  "translation": "Faith-based"
              },
              {
                  "source": "app-us-program-meeting-juvenile",
                  "translation": "Juvenile correction facility"
              },
              {
                  "source": "app-us-program-meeting-mental",
                  "translation": "Mental health / treatment facility"
              },
              {
                  "source": "app-us-program-meeting-school",
                  "translation": "School"
              },
              {
                  "source": "app-us-program-meeting-workplace",
                  "translation": "Workplace"
              },
              {
                  "source": "app-us-program-focus-meeting-school",
                  "translation": "After school"
              },
              {
                  "source": "app-us-program-meeting-online",
                  "translation": "Online"
              },
              {
                  "source": "app-ca-program-operated-business",
                  "translation": "Business"
              },
              {
                  "source": "app-ca-program-operated-community-based organization",
                  "translation": "Community-based organization"
              },
              {
                  "source": "app-ca-program-operated-foundation-or-philanthropic-organization",
                  "translation": "Foundation or philanthropic organization"
              },
              {
                  "source": "app-ca-program-operated-employment-agency",
                  "translation": "Employment agency"
              },
              {
                  "source": "app-ca-program-operated-faith-based-organization",
                  "translation": "Faith-based organization"
              },
              {
                  "source": "app-ca-program-operated-government-agency",
                  "translation": "Government (federal, provincial, municipal) agency"
              },
              {
                  "source": "app-ca-program-operated-higher-education-post-secondary-institution",
                  "translation": "Higher education / post-secondary institution"
              },
              {
                  "source": "app-ca-program-operated-resident-treatment-facility",
                  "translation": "Residential / treatment facility"
              },
              {
                  "source": "app-ca-program-operated-correctional-facility",
                  "translation": "Correctional facility"
              },
              {
                  "source": "app-ca-program-operated-school",
                  "translation": "School (elementary / primary, middle, secondary)"
              },
              {
                  "source": "app-us-program-operated-business",
                  "translation": "Business"
              },
              {
                  "source": "app-us-program-operated-community",
                  "translation": "Community-based organization"
              },
              {
                  "source": "app-us-program-operated-faith",
                  "translation": "Faith-based organization"
              },
              {
                  "source": "app-us-program-operated-government",
                  "translation": "Government / state agency"
              },
              {
                  "source": "app-us-program-operated-higher-education",
                  "translation": "Higher education institution"
              },
              {
                  "source": "app-us-program-operated-resident",
                  "translation": "Resident / treatment facility"
              },
              {
                  "source": "app-us-program-operated-school",
                  "translation": "School"
              },
              {
                  "source": "app-ca-male",
                  "translation": "Male"
              },
              {
                  "source": "app-ca-female",
                  "translation": "Female"
              },
              {
                  "source": "app-ca-genderqueer",
                  "translation": "Genderqueer"
              },
              {
                  "source": "app-ca-non-binary",
                  "translation": "Non-binary"
              },
              {
                  "source": "app-ca-two-spirit",
                  "translation": "Two-spirit"
              },
              {
                  "source": "app-ca-transgender",
                  "translation": "Transgender"
              },
              {
                  "source": "app-us-male",
                  "translation": "Male"
              },
              {
                  "source": "app-us-female",
                  "translation": "Female"
              },
              {
                  "source": "app-us-genderqueer",
                  "translation": "Genderqueer"
              },
              {
                  "source": "app-us-non-binary",
                  "translation": "Non-binary"
              },
              {
                  "source": "app-us-two-spirit",
                  "translation": "Two-spirit"
              },
              {
                  "source": "app-ca-7-and-under",
                  "translation": "7 and under"
              },
              {
                  "source": "app-ca-8-11",
                  "translation": "8 to 11"
              },
              {
                  "source": "app-ca-12-14",
                  "translation": "12 to 14"
              },
              {
                  "source": "app-ca-15-17",
                  "translation": "15 to 17"
              },
              {
                  "source": "app-ca-18-24",
                  "translation": "18 to 24"
              },
              {
                  "source": "app-ca-25-and-over",
                  "translation": "25 and over"
              },
              {
                  "source": "app-us-7-and-under",
                  "translation": "7 and under"
              },
              {
                  "source": "app-us-8-10",
                  "translation": "8 to 10"
              },
              {
                  "source": "app-us-11-14",
                  "translation": "11 to 14"
              },
              {
                  "source": "app-us-15-18",
                  "translation": "15 to 18"
              },
              {
                  "source": "app-us-19-24",
                  "translation": "19 to 24"
              },
              {
                  "source": "app-ca-foster-care",
                  "translation": "Foster care"
              },
              {
                  "source": "app-ca-group-home",
                  "translation": "Group home"
              },
              {
                  "source": "app-ca-guardian",
                  "translation": "Guardian"
              },
              {
                  "source": "app-ca-kinship-care",
                  "translation": "Kinship care (non-parental relationship)"
              },
              {
                  "source": "app-ca-single-parent-family",
                  "translation": "Single-parent family"
              },
              {
                  "source": "app-ca-two-parent-family",
                  "translation": "Two-parent family"
              },
              {
                  "source": "app-us-foster-care",
                  "translation": "Foster care"
              },
              {
                  "source": "app-us-group-home",
                  "translation": "Group home"
              },
              {
                  "source": "app-us-guardian",
                  "translation": "Guardian"
              },
              {
                  "source": "app-us-kinship-care",
                  "translation": "Kinship care (non-parental relationship)"
              },
              {
                  "source": "app-us-single-parent-family",
                  "translation": "Single-parent family"
              },
              {
                  "source": "app-us-two-parent-family",
                  "translation": "Two-parent family"
              },
              {
                  "source": "app-ca-academically-at-risk",
                  "translation": "Academically at-risk"
              },
              {
                  "source": "app-ca-college-post-secondary-student",
                  "translation": "College / post-secondary student"
              },
              {
                  "source": "app-ca-foster-residential-or-kinship-care",
                  "translation": "Foster, residential or kinship care"
              },
              {
                  "source": "app-ca-gang-involved-or-gang-at-risk",
                  "translation": "Gang involved or gang at-risk"
              },
              {
                  "source": "app-ca-gifted-talented-academic-achiever",
                  "translation": "Gifted / talented / academic achiever"
              },
              {
                  "source": "app-ca-incarcerated-parent",
                  "translation": "Incarcerated parent"
              },
              {
                  "source": "app-ca-low-income",
                  "translation": "Low income"
              },
              {
                  "source": "app-ca-neet-opportunity-youth",
                  "translation": "NEET (Not in education, employment or training) / opportunity youth"
              },
              {
                  "source": "app-ca-physical-disabilities-special-care-needs",
                  "translation": "Disabilities / special care needs"
              },
              {
                  "source": "app-ca-recent-immigrant-refugee",
                  "translation": "Newcomer / recent immigrant / refugee"
              },
              {
                  "source": "app-ca-single-parent-household",
                  "translation": "Single-parent household"
              },
              {
                  "source": "app-ca-adjudicated-court-involved",
                  "translation": "Adjudicated / court involved"
              },
              {
                  "source": "app-ca-emancipated",
                  "translation": "Emancipated"
              },
              {
                  "source": "app-ca-general-youth-population",
                  "translation": "General youth population"
              },
              {
                  "source": "app-ca-homeless-living-in-a-shelter",
                  "translation": "Homeless / living in a shelter"
              },
              {
                  "source": "app-ca-lgbtq-youth",
                  "translation": "LGBTQ+ youth"
              },
              {
                  "source": "app-ca-mental-health-needs",
                  "translation": "Mental health needs"
              },
              {
                  "source": "app-ca-parent-involved-in-military",
                  "translation": "Parent involved in military"
              },
              {
                  "source": "app-ca-pregnant-parenting",
                  "translation": "Pregnant / parenting"
              },
              {
                  "source": "app-ca-school-drop-out",
                  "translation": "School drop-out"
              },
              {
                  "source": "app-ca-special-education",
                  "translation": "Special education"
              },
              {
                  "source": "app-us-academically-at-risk",
                  "translation": "Academically at-risk"
              },
              {
                  "source": "app-us-college-post-secondary-student",
                  "translation": "College / post-secondary student"
              },
              {
                  "source": "app-us-foster-residential-or-kinship-care",
                  "translation": "Foster, residential or kinship care"
              },
              {
                  "source": "app-us-gang-involved",
                  "translation": "Gang involved"
              },
              {
                  "source": "app-us-gifted-talented-academic-achiever",
                  "translation": "Gifted / talented / academic achiever"
              },
              {
                  "source": "app-us-incarcerated-parent",
                  "translation": "Incarcerated parent"
              },
              {
                  "source": "app-us-low-income",
                  "translation": "Low income"
              },
              {
                  "source": "app-us-opportunity-youth",
                  "translation": "Opportunity youth"
              },
              {
                  "source": "app-us-physical-disabilities-special-care-needs",
                  "translation": "Disabilities / special care needs"
              },
              {
                  "source": "app-us-recent-immigrant-refugee",
                  "translation": "Newcomer / Recent immigrant / refugee"
              },
              {
                  "source": "app-us-single-parent-household",
                  "translation": "Single-parent household"
              },
              {
                  "source": "app-us-youth-with-disabilities",
                  "translation": "Youth with disabilities"
              },
              {
                  "source": "app-us-adjudicated-court-involved",
                  "translation": "Adjudicated / court involved"
              },
              {
                  "source": "app-us-first-generation-college",
                  "translation": "First-generation college"
              },
              {
                  "source": "app-us-gang-at-risk",
                  "translation": "Gang at-risk"
              },
              {
                  "source": "app-us-general-youth-population",
                  "translation": "General youth population"
              },
              {
                  "source": "app-us-homeless-runaway",
                  "translation": "Homeless / runaway"
              },
              {
                  "source": "app-us-lgbtq-youth",
                  "translation": "LGBTQ youth"
              },
              {
                  "source": "app-us-mental-health-issues",
                  "translation": "Mental health issues"
              },
              {
                  "source": "app-us-parent-involved-in-military",
                  "translation": "Parent involved in military"
              },
              {
                  "source": "app-us-pregnant-parenting",
                  "translation": "Pregnant / parenting"
              },
              {
                  "source": "app-us-school-drop-out",
                  "translation": "School drop-out"
              },
              {
                  "source": "app-us-special-education",
                  "translation": "Special education"
              },
              {
                  "source": "app-ca-age-under-18",
                  "translation": "Under 18"
              },
              {
                  "source": "app-ca-age-18-24",
                  "translation": "18 to 24"
              },
              {
                  "source": "app-ca-age-25-34",
                  "translation": "25 to 34"
              },
              {
                  "source": "app-ca-age-35-49",
                  "translation": "35 to 49"
              },
              {
                  "source": "app-ca-age-50-65",
                  "translation": "50 to 65"
              },
              {
                  "source": "app-ca-age-over-65",
                  "translation": "65 and over"
              },
              {
                  "source": "app-ca-academic-enrichment",
                  "translation": "Academic enrichment"
              },
              {
                  "source": "app-ca-bullying-prevention",
                  "translation": "Bullying prevention"
              },
              {
                  "source": "app-ca-career-exploration-job-readiness-employability",
                  "translation": "Career exploration / job readiness / employability"
              },
              {
                  "source": "app-ca-job-placement",
                  "translation": "Job placement"
              },
              {
                  "source": "app-ca-civic-engagement",
                  "translation": "Civic engagement"
              },
              {
                  "source": "app-ca-post-secondary-access-and-or-completion",
                  "translation": "Post-secondary access and / or completion"
              },
              {
                  "source": "app-ca-educational-attainment-direct-academic-support",
                  "translation": "Educational attainment / direct academic support"
              },
              {
                  "source": "app-ca-family-support",
                  "translation": "Family support"
              },
              {
                  "source": "app-ca-positive-youth-development",
                  "translation": "Positive youth development"
              },
              {
                  "source": "app-ca-identity-development",
                  "translation": "Identity development"
              },
              {
                  "source": "app-ca-indigenous-identity-development",
                  "translation": "Indigenous identity development"
              },
              {
                  "source": "app-ca-juvenile-justice-re-entry",
                  "translation": "Juvenile justice / re-entry"
              },
              {
                  "source": "app-ca-leadership-development",
                  "translation": "Leadership development"
              },
              {
                  "source": "app-ca-life-skills",
                  "translation": "Life skills"
              },
              {
                  "source": "app-ca-social-emotional-learning",
                  "translation": "Social emotional learning"
              },
              {
                  "source": "app-ca-literacy",
                  "translation": "Literacy"
              },
              {
                  "source": "app-ca-mental-health-and-wellbeing",
                  "translation": "Mental health and wellbeing"
              },
              {
                  "source": "app-ca-positive-health-behaviours",
                  "translation": "Positive health behaviours"
              },
              {
                  "source": "app-ca-pregnancy-prevention",
                  "translation": "Pregnancy prevention"
              },
              {
                  "source": "app-ca-developmental-relationship",
                  "translation": "Developmental relationship"
              },
              {
                  "source": "app-ca-recreational-activities-hobbies",
                  "translation": "Recreational activities / hobbies"
              },
              {
                  "source": "app-ca-resiliency",
                  "translation": "Resiliency"
              },
              {
                  "source": "app-ca-stem",
                  "translation": "STEM"
              },
              {
                  "source": "app-ca-substance-use",
                  "translation": "Substance use"
              },
              {
                  "source": "app-ca-violence-prevention-reduction-in-aggression",
                  "translation": "Violence prevention / reduction in aggression"
              },
              {
                  "source": "app-us-career-exploration",
                  "translation": "Career exploration"
              },
              {
                  "source": "app-us-education-academic-support",
                  "translation": "Education / academic support"
              },
              {
                  "source": "app-us-friendship-socialization",
                  "translation": "Friendship / socialization"
              },
              {
                  "source": "app-us-healthy-behaviours",
                  "translation": "Healthy behaviours"
              },
              {
                  "source": "app-us-job-placement-performance",
                  "translation": "Job placement / performance"
              },
              {
                  "source": "app-us-reduce-recidivism",
                  "translation": "Reduce recidivism"
              },
              {
                  "source": "app-mentor-role-description",
                  "translation": "Mentor Role Description"
              },
              {
                  "source": "app-program-volunteer-coordinator-same-as-admin",
                  "translation": "Is the volunteer coordinator the same as the program administrator?"
              },
              {
                  "source": "app-program-volunteer-coordinator-manager-exists",
                  "translation": "Do you have a volunteer coordinator / manager?"
              },
              {
                  "source": "app-program-focus-area",
                  "translation": "Program Focus Area"
              },
              {
                  "source": "app-program-primary-meeting-location",
                  "translation": "Primary Meeting Location"
              },
              {
                  "source": "app-program-type-of-mentoring",
                  "translation": "Types of mentoring opportunities offered"
              },
              {
                  "source": "app-program-operated-through",
                  "translation": "Program operated through"
              },
              {
                  "source": "app-program-how-are-meetings-scheduled",
                  "translation": "How are mentoring meetings scheduled?"
              },
              {
                  "source": "app-program-genders-program-serves",
                  "translation": "Gender(s) program serves"
              },
              {
                  "source": "app-program-ages-program-serves",
                  "translation": "Age(s) program serves"
              },
              {
                  "source": "app-program-family-structures-program-serves",
                  "translation": "Family structure(s) program serves"
              },
              {
                  "source": "app-program-youth-program-serves",
                  "translation": "Youth served"
              },
              {
                  "source": "app-program-target-mentor-population-genders",
                  "translation": "Target mentor gender(s)"
              },
              {
                  "source": "app-program-target-mentor-population-ages",
                  "translation": "Target mentor age(s)"
              },
              {
                  "source": "app-program-mentoring-relationship-commitment-months",
                  "translation": "Minimum Match Commitment"
              },
              {
                  "source": "app-program-mentoring-relationship-commitment-frequency",
                  "translation": "Meeting Frequency"
              },
              {
                  "source": "app-program-mentoring-relationship-commitment-hours-per-week",
                  "translation": "Meeting Duration"
              },
              {
                  "source": "app-standing",
                  "translation": "Standing"
              },
              {
                  "source": "app-program-screens-mentors",
                  "translation": "Does the program screen mentors?"
              },
              {
                  "source": "app-program-screens-mentors-how",
                  "translation": "How does the program screen mentors?"
              },
              {
                  "source": "app-program-screens-mentees",
                  "translation": "Does the program screen mentees?"
              },
              {
                  "source": "app-program-screens-mentees-how",
                  "translation": "How does the program screen mentees?"
              },
              {
                  "source": "app-program-provides-pre-match-training-to-mentors",
                  "translation": "Does this program provide pre-match training to mentors?"
              },
              {
                  "source": "app-program-provides-pre-match-training-to-mentors-how",
                  "translation": "How is training delivered to mentors?"
              },
              {
                  "source": "app-program-provides-pre-match-training-to-mentors-mandatory",
                  "translation": "Is training mandatory for mentors?"
              },
              {
                  "source": "app-program-provides-pre-match-training-to-mentees",
                  "translation": "Does this program provide pre-match training to mentees?"
              },
              {
                  "source": "app-program-provides-pre-match-training-to-mentees-how",
                  "translation": "How is training delivered to mentees?"
              },
              {
                  "source": "app-program-provides-pre-match-training-to-mentees-mandatory",
                  "translation": "Is training mandatory for mentees?"
              },
              {
                  "source": "app-program-how-does-your-program-match-mentors-to-mentees",
                  "translation": "How does your program match mentors to mentees?"
              },
              {
                  "source": "app-does-your-program-provide-ongoing-monitoring-and-support-to-the-mentoring-relationship",
                  "translation": "Does your program provide ongoing monitoring and support to the mentoring relationship?"
              },
              {
                  "source": "app-is-there-a-formal-beginning-and-end-to-the-mentoring-relationship",
                  "translation": "Is there a formal beginning and end to the mentoring relationship (e.g. 1:1 match) and / or mentoring program (e.g. group)?"
              },
              {
                  "source": "app-does-your-program-have-specific-goals-or-outcomes",
                  "translation": "Does your program have specific goals or outcomes?"
              },
              {
                  "source": "app-does-your-program-have-specific-goals-or-outcomes-which",
                  "translation": "Which specific goals or outcomes does your program have?"
              },
              {
                  "source": "app-does-your-program-have-specific-goals-or-outcomes-which-other",
                  "translation": "Program Goals - Other"
              },
              {
                  "source": "app-program-administration",
                  "translation": "Program Administration"
              },
              {
                  "source": "app-program-administrator-name",
                  "translation": "Administrator Name"
              },
              {
                  "source": "app-program-administrator-role",
                  "translation": "Administrator Role"
              },
              {
                  "source": "app-program-administrator-contact",
                  "translation": "Administrator Contact"
              },
              {
                  "source": "app-program-volunteer-administrator-name",
                  "translation": "Volunteer Coordinator Name"
              },
              {
                  "source": "app-program-volunteer-administrator-role",
                  "translation": "Volunteer Coordinator Role"
              },
              {
                  "source": "app-program-volunteer-administrator-contact",
                  "translation": "Volunteer Coordinator Contact"
              },
              {
                  "source": "app-program-physical-locations",
                  "translation": "Program Physical Locations"
              },
              {
                  "source": "app-location",
                  "translation": "Physical Location(s)"
              },
              {
                  "source": "app-program-regions",
                  "translation": "Program Region(s) / Area(s) of Service"
              },
              {
                  "source": "app-program-regions-label",
                  "translation": "Area(s) the Program (Not Parent Organization) Services"
              },
              {
                  "source": "app-ca-program-number-of-locations",
                  "translation": "Number of Sites / Locations / Schools This Program Listing Represents"
              },
              {
                  "source": "app-us-program-number-of-locations",
                  "translation": "Number of Sites / Chapters This Program Listing Represents"
              },
              {
                  "source": "app-program-social-media-links",
                  "translation": "Program Social Media Links"
              },
              {
                  "source": "app-program-faceboook",
                  "translation": "Facebook"
              },
              {
                  "source": "app-program-twitter",
                  "translation": "Twitter"
              },
              {
                  "source": "app-program-website",
                  "translation": "Website"
              },
              {
                  "source": "app-program-instagram",
                  "translation": "Instagram"
              },
              {
                  "source": "app-program-details",
                  "translation": "Program Details"
              },
              {
                  "source": "app-program-estimated-number-of-youth-served-per-year",
                  "translation": "Estimated Number of Youth Served Per Year"
              },
              {
                  "source": "app-program-estimated-number-of-mentees-on-waiting-list",
                  "translation": "Estimated Number of Mentees on Waiting List"
              },
              {
                  "source": "app-program-facebook",
                  "translation": "Facebook"
              },
              {
                  "source": "app-next",
                  "translation": "Next"
              },
              {
                  "source": "app-program-vetting",
                  "translation": "Program Vetting"
              },
              {
                  "source": "app-no-formal-matching-please-explain",
                  "translation": "How does your program match mentors to mentees? - Other"
              },
              {
                  "source": "app-program-is-virtual",
                  "translation": "Is the program delivered virtually?"
              },
              {
                  "source": "app-program-focus-area-other",
                  "translation": "Program Focus Area - Other"
              },
              {
                  "source": "app-program-primary-meeting-location-other",
                  "translation": "Primary Meeting Location - Other"
              },
              {
                  "source": "app-program-type-of-mentoring-other",
                  "translation": "Types of Mentoring Opportunities Offered - Other"
              },
              {
                  "source": "app-program-operated-through-other",
                  "translation": "Program Operated Through - Other"
              },
              {
                  "source": "app-program-genders-program-serves-other",
                  "translation": "Gender(s) Program Serves - Additional"
              },
              {
                  "source": "app-program-ages-program-serves-other",
                  "translation": "Age(s) Program Serves - Other"
              },
              {
                  "source": "app-program-family-structures-program-serves-other",
                  "translation": "Family Structure(s) Program Serves - Other"
              },
              {
                  "source": "app-program-youth-program-serves-other",
                  "translation": "Youth Served - Other"
              },
              {
                  "source": "app-program-target-mentor-population-genders-other",
                  "translation": "Target Mentor Gender(s) - Additional"
              },
              {
                  "source": "app-program-target-mentor-population-ages-other",
                  "translation": "Target Mentor Age(s) - Other"
              },
              {
                  "source": "app-program-mentoring-relationship-commitment-frequency-other",
                  "translation": "Meeting Frequency - Other"
              },
              {
                  "source": "app-program-mentoring-relationship-commitment-hours-per-week-other",
                  "translation": "Average Hours Per Week - Other"
              },
              {
                  "source": "app-program-commitment",
                  "translation": "Length of Program Commitment"
              },
              {
                  "source": "app-mentor-connector",
                  "translation": "Mentoring Connector"
              },
              {
                  "source": "app-search-role-in-mentoring",
                  "translation": "What are you looking to do?"
              },
              {
                  "source": "app-seach-distance",
                  "translation": "Within"
              },
              {
                  "source": "app-search-focus-of-mentoring",
                  "translation": "Program Focus Area"
              },
              {
                  "source": "app-search-age-of-youth-served",
                  "translation": "Age of Youth Served"
              },
              {
                  "source": "app-youth-served",
                  "translation": "Youth Served"
              },
              {
                  "source": "app-search-type-of-mentoring",
                  "translation": "Type of Mentoring"
              },
              {
                  "source": "app-how-did-you-hear-about-us",
                  "translation": "How Did You Hear About Us?"
              },
              {
                  "source": "app-5-km",
                  "translation": "5 kilometres"
              },
              {
                  "source": "app-10-km",
                  "translation": "10 kilometres"
              },
              {
                  "source": "app-15-km",
                  "translation": "15 kilometres"
              },
              {
                  "source": "app-25-km",
                  "translation": "25 kilometres"
              },
              {
                  "source": "app-5-miles",
                  "translation": "5 miles"
              },
              {
                  "source": "app-10-miles",
                  "translation": "10 miles"
              },
              {
                  "source": "app-15-miles",
                  "translation": "15 miles"
              },
              {
                  "source": "app-25-miles",
                  "translation": "25 miles"
              },
              {
                  "source": "app-ca-postal-code-name",
                  "translation": "Postal Code"
              },
              {
                  "source": "app-us-postal-code-name",
                  "translation": "ZIP Code"
              },
              {
                  "source": "app-ca-hear-about-us-mentoring-canada-website",
                  "translation": "Mentoring Canada website"
              },
              {
                  "source": "app-ca-hear-about-us-alberta-mentoring-partnership",
                  "translation": "Alberta Mentoring Partnership"
              },
              {
                  "source": "app-ca-hear-about-us-ontario-mentoring-coalition",
                  "translation": "Ontario Mentoring Coalition"
              },
              {
                  "source": "app-ca-hear-about-us-linkedin",
                  "translation": "LinkedIn"
              },
              {
                  "source": "app-ca-hear-about-us-mentoring-partnership-in-my-province-region",
                  "translation": "Mentoring Partnership in my province / region"
              },
              {
                  "source": "app-ca-hear-about-us-national-mentoring-month-materials",
                  "translation": "National Mentoring Month materials"
              },
              {
                  "source": "app-us-hear-about-us-mentor-web-site",
                  "translation": "Mentor website"
              },
              {
                  "source": "app-us-hear-about-us-my-brothers-keeper-initiative",
                  "translation": "My Brother's Keeper Initiative"
              },
              {
                  "source": "app-us-hear-about-us-linkedin",
                  "translation": "LinkedIn"
              },
              {
                  "source": "app-us-hear-about-us-nba-cares-mentoring-campaign",
                  "translation": "NBA Cares mentoring campaign"
              },
              {
                  "source": "app-us-hear-about-us-mentoring-partnership-in-my-state",
                  "translation": "Mentoring partnership in my state"
              },
              {
                  "source": "app-us-hear-about-us-coachers-mentoring-challenge",
                  "translation": "Coachers' Mentoring Challenge"
              },
              {
                  "source": "app-us-hear-about-us-national-mentoring-month-materials-website",
                  "translation": "National Mentoring Month materials / website"
              },
              {
                  "source": "app-us-hear-about-us-the-in-real-life-campaign",
                  "translation": "The In Real Life Campaign"
              },
              {
                  "source": "app-us-hear-about-us-mentoring-flipped",
                  "translation": "Mentoring Flipped"
              },
              {
                  "source": "app-us-hear-about-us-mentor-gov",
                  "translation": "mentor.gov"
              },
              {
                  "source": "app-us-hear-about-us-american-graduate",
                  "translation": "American Graduate"
              },
              {
                  "source": "app-us-hear-about-us-generation-to-generation",
                  "translation": "Generation to Generation"
              },
              {
                  "source": "app-us-hear-about-us-equality",
                  "translation": "Equality."
              },
              {
                  "source": "app-us-hear-about-us-yes-project",
                  "translation": "YES Project"
              },
              {
                  "source": "app-all",
                  "translation": "All"
              },
              {
                  "source": "app-how-did-you-hear-about-us-other",
                  "translation": "How Did You Hear About Us? - Other"
              },
              {
                  "source": "app-search-distance",
                  "translation": "Distance"
              },
              {
                  "source": "app-profile",
                  "translation": "Profile"
              },
              {
                  "source": "app-sign-out",
                  "translation": "Sign Out"
              },
              {
                  "source": "app-edit-account",
                  "translation": "Edit Account"
              },
              {
                  "source": "app-add-account",
                  "translation": "Add Account"
              },
              {
                  "source": "app-mentoring-connector",
                  "translation": "Mentoring Connector"
              },
              {
                  "source": "app-become-a-mentor",
                  "translation": "Become a mentor"
              },
              {
                  "source": "app-become-a-mentee",
                  "translation": "Find a mentor for myself or someone else"
              },
              {
                  "source": "app-prev",
                  "translation": "Previous"
              },
              {
                  "source": "app-country",
                  "translation": "Country"
              },
              {
                  "source": "app-title",
                  "translation": "Title"
              },
              {
                  "source": "app-created",
                  "translation": "Created"
              },
              {
                  "source": "app-open-administrative-menu",
                  "translation": "Open Administrative Menu"
              },
              {
                  "source": "app-close-administrative-menu",
                  "translation": "Close Administrative Menu"
              },
              {
                  "source": "app-approval-organization",
                  "translation": "Your approval of the organization"
              },
              {
                  "source": "app-approval-program",
                  "translation": "Your approval of the program"
              },
              {
                  "source": "app-program-settings",
                  "translation": "Program Settings"
              },
              {
                  "source": "app-program-settings-approval",
                  "translation": "Approval of the '${programName}' Program"
              },
              {
                  "source": "app-program-settings-description",
                  "translation": "Review how other administrators have approved of this program in the table below, and indicate your own approval. Programs are approved if any administrator has indicated their approval, and disapproved if any administrator has selected to deny. Select 'Pending' to indicate that you are considering their status. You may clear your selection if you do not wish to weigh in on this programs's status."
              },
              {
                  "source": "app-region-physical-locations",
                  "translation": "Region Properties"
              },
              {
                  "source": "app-us-age-under-18",
                  "translation": "Under 18"
              },
              {
                  "source": "app-us-age-18-24",
                  "translation": "18 to 24"
              },
              {
                  "source": "app-us-age-25-34",
                  "translation": "25 to 34"
              },
              {
                  "source": "app-us-age-35-49",
                  "translation": "35 to 49"
              },
              {
                  "source": "app-us-age-50-65",
                  "translation": "50 to 65"
              },
              {
                  "source": "app-us-age-over-65",
                  "translation": "Over 65"
              },
              {
                  "source": "app-any",
                  "translation": "All"
              },
              {
                  "source": "app-pending",
                  "translation": "Pending"
              },
              {
                  "source": "app-program-submitted-headline",
                  "translation": "Congratulations!"
              },
              {
                  "source": "app-program-submitted-subtitle",
                  "translation": "The program '${programName}' has been submitted for review."
              },
              {
                  "source": "app-program-submitted-paragraph",
                  "translation": "We'll follow-up with you shortly by email at ${email}. Thank you for supporting mentoring in your community."
              },
              {
                  "source": "app-email-program-submited-receipt",
                  "translation": "Program Submitted"
              },
              {
                  "source": "app-email-program-submitted-paragraph-1",
                  "translation": "Thank you for submitting the '@programName' program to the Mentoring Connector."
              },
              {
                  "source": "app-email-program-submitted-paragraph-2",
                  "translation": "The program's application is under review."
              },
              {
                  "source": "app-email-program-submitted-paragraph-3",
                  "translation": "We'll follow-up with you shortly. Thank you for supporting mentoring in your community."
              },
              {
                  "source": "app-email-program-admin-notification-paragraph-1",
                  "translation": "@firstName @lastName has submitted the program '@programName' for review."
              },
              {
                  "source": "app-email-program-admin-notification-paragraph-2",
                  "translation": "To review the program, click the following link."
              },
              {
                  "source": "app-email-program-admin-notification-link",
                  "translation": "Review the program"
              },
              {
                  "source": "app-approval-notes",
                  "translation": "Status Notes"
              },
              {
                  "source": "app-clear-approval",
                  "translation": "Clear Approval Status"
              },
              {
                  "source": "app-approval-notes-legend",
                  "translation": "Status Notes"
              },
              {
                  "source": "app-approval-notes-description",
                  "translation": "Optionally provide notes regarding your status selection to share with other administrators."
              },
              {
                  "source": "app-checkbox-required-tip",
                  "translation": "Select at least one option, check all that apply."
              },
              {
                  "source": "app-checkbox-not-required-tip",
                  "translation": "Check all that apply."
              },
              {
                  "source": "app-are-you-sure",
                  "translation": "Are you sure?"
              },
              {
                  "source": "app-are-you-sure-delete-organization",
                  "translation": "Are you sure you want to delete the organization"
              },
              {
                  "source": "app-cannot-be-undone",
                  "translation": "This cannot be undone."
              },
              {
                  "source": "app-cancel",
                  "translation": "Cancel"
              },
              {
                  "source": "app-are-you-sure-you-want-to-delete",
                  "translation": "Are you sure you want to delete"
              },
              {
                  "source": "app-review-organization-settings",
                  "translation": "Administer Organization Settings"
              },
              {
                  "source": "app-review-organization-details",
                  "translation": "Organization Details"
              },
              {
                  "source": "app-review-program-settings",
                  "translation": "Administer Program Settings"
              },
              {
                  "source": "app-review-program-details",
                  "translation": "Program Details"
              },
              {
                  "source": "app-save",
                  "translation": "Save"
              },
              {
                  "source": "app-submit-another-program",
                  "translation": "Submit Another Program"
              },
              {
                  "source": "app-submit-a-program",
                  "translation": "Submit a Program"
              },
              {
                  "source": "app-submit-another-organization",
                  "translation": "Submit Another Organization"
              },
              {
                  "source": "app-submit-an-organization",
                  "translation": "Submit an Organization"
              },
              {
                  "source": "app-return-to-mentor-canada",
                  "translation": "Return to MENTOR Canada"
              },
              {
                  "source": "app-edit-program",
                  "translation": "Edit Program"
              },
              {
                  "source": "app-user",
                  "translation": "User"
              },
              {
                  "source": "app-notes",
                  "translation": "Notes"
              },
              {
                  "source": "app-status",
                  "translation": "Status"
              },
              {
                  "source": "app-no-data-available",
                  "translation": "No data available"
              },
              {
                  "source": "app-search-users",
                  "translation": "Search Users"
              },
              {
                  "source": "app-name",
                  "translation": "Name"
              },
              {
                  "source": "app-edit-organization",
                  "translation": "Edit Organization"
              },
              {
                  "source": "app-submit-program",
                  "translation": "Submit Program"
              },
              {
                  "source": "app-organization-submitted",
                  "translation": "Organization Submitted"
              },
              {
                  "source": "app-program-submitted",
                  "translation": "Program Submitted"
              },
              {
                  "source": "app-organization-hours-of-operation",
                  "translation": "Hours of Operation"
              },
              {
                  "source": "app-organization-type",
                  "translation": "Organization Type"
              },
              {
                  "source": "app-organization-type-school-board",
                  "translation": "School Board"
              },
              {
                  "source": "app-organization-type-school-academic-institution",
                  "translation": "School / Academic Institution"
              },
              {
                  "source": "app-organization-contact-description",
                  "translation": "Please list the individual in a leadership position for the organization."
              },
              {
                  "source": "app-organization-tax-status-for-profit",
                  "translation": "For Profit"
              },
              {
                  "source": "app-organization-tax-status-not-for-profit",
                  "translation": "Not for Profit"
              },
              {
                  "source": "app-organization-tax-status-registered-charity",
                  "translation": "Registered Charity"
              },
              {
                  "source": "app-organization-tax-status-n-a",
                  "translation": "N/A"
              },
              {
                  "source": "app-organization-position-founder",
                  "translation": "Founder"
              },
              {
                  "source": "app-organization-position-president-ceo",
                  "translation": "President / CEO"
              },
              {
                  "source": "app-organization-position-executive-director",
                  "translation": "Executive Director"
              },
              {
                  "source": "app-organization-position-vice-president",
                  "translation": "Vice President"
              },
              {
                  "source": "app-organization-position-director",
                  "translation": "Director"
              },
              {
                  "source": "app-organization-position-chair",
                  "translation": "Chair"
              },
              {
                  "source": "app-organization-tax-status-other",
                  "translation": "Tax Status - Other"
              },
              {
                  "source": "app-contact-position-other",
                  "translation": "Position - Other"
              },
              {
                  "source": "app-organization-general-information",
                  "translation": "General Information"
              },
              {
                  "source": "app-program-general-information",
                  "translation": "Program Information"
              },
              {
                  "source": "app-organization-type-other",
                  "translation": "Organization Type - Other"
              },
              {
                  "source": "app-organization-has-physical-location",
                  "translation": "Does your organization have a physical address?"
              },
              {
                  "source": "app-organization-bilingual-description",
                  "translation": "If you would like to have a bilingual listing for your organization, please complete both English and French fields. If not, please complete fields in the language of your preference."
              },
              {
                  "source": "app-program-contact",
                  "translation": "Program Contact Information"
              },
              {
                  "source": "app-program-bilingual-description",
                  "translation": "If you would like to have a bilingual listing for your program, please complete both English and French fields. If not, please complete fields in the language of your preference."
              },
              {
                  "source": "app-ca-blended-family",
                  "translation": "Blended Family"
              },
              {
                  "source": "app-program-name-description",
                  "translation": "This is how the program will be listed in Mentoring Connector"
              },
              {
                  "source": "app-organization-name-description",
                  "translation": "This is how the organization will be listed in Mentoring Connector"
              },
              {
                  "source": "app-add-new-organization-pre",
                  "translation": "Don't see your organization in the list above?"
              },
              {
                  "source": "app-add-new-organization",
                  "translation": "Click here to add an organization for this program."
              },
              {
                  "source": "app-add-new-organization-post",
                  "translation": "You will be redirected back to this form after submitting an organization. Don't worry, you won't lose any information you've already entered."
              },
              {
                  "source": "app-program-how-are-meetings-scheduled-other",
                  "translation": "How Are Mentoring Meetings Scheduled - Other"
              },
              {
                  "source": "app-program-mentoring-relationship-commitment-months-other",
                  "translation": "Monthly Commitment - Other"
              },
              {
                  "source": "app-program-post-organization-submission-description",
                  "translation": "Your organization has been submitted and is pending approval. After completing this form, you will have the option to add another program. The organization you have just submitted will be available to be associated with any new programs you create during this session. If you close your browser window you will no longer be able to associate this organization with new programs until it has been approved."
              },
              {
                  "source": "app-program-post-organization-submission-legend",
                  "translation": "Organization Submitted"
              },
              {
                  "source": "app-English",
                  "translation": "English"
              },
              {
                  "source": "app-French",
                  "translation": "Français"
              },
              {
                  "source": "app-sitename",
                  "translation": "MENTOR National"
              },
              {
                  "source": "app-footer-contact-us",
                  "translation": "Contact Us"
              },
              {
                  "source": "app-footer-phone-link",
                  "translation": "tel:16173034600"
              },
              {
                  "source": "app-footer-phone-display",
                  "translation": "617.303.4600"
              },
              {
                  "source": "app-footer-email-link",
                  "translation": "mailto:connector@mentoring.org"
              },
              {
                  "source": "app-footer-email-display",
                  "translation": "connector@mentoring.org"
              },
              {
                  "source": "app-footer-subscribe-to-newsletter",
                  "translation": "Subscribe to our newsletter!"
              },
              {
                  "source": "app-footer-subscribe",
                  "translation": "Subscribe"
              },
              {
                  "source": "app-footer-subscribe-to-newsletter-link",
                  "translation": "https://www.mentoringcanada.ca/en/newsletter"
              },
              {
                  "source": "app-footer-founding-partners",
                  "translation": "Founding Partners"
              },
              {
                  "source": "app-footer-bbbsc-src",
                  "translation": "https://www.mentoringcanada.ca/assets/partner-logos/bbbsc-en-logo.png"
              },
              {
                  "source": "app-footer-bbbsc-alt",
                  "translation": "Big Brothers Big Sisters of Canada"
              },
              {
                  "source": "app-footer-bbbsc-style",
                  "translation": "width: 105px; height: 42.5px"
              },
              {
                  "source": "app-footer-omc-src",
                  "translation": "https://www.mentoringcanada.ca/assets/partner-logos/omc-logo.png"
              },
              {
                  "source": "app-footer-omc-alt",
                  "translation": "Ontario Mentoring Coalition"
              },
              {
                  "source": "app-footer-omc-style",
                  "translation": "width: 116px; height: 56.5px"
              },
              {
                  "source": "app-footer-amp-src",
                  "translation": "https://www.mentoringcanada.ca/assets/partner-logos/amp-logo.png"
              },
              {
                  "source": "app-footer-amp-alt",
                  "translation": "Alberta Mentoring Partnership"
              },
              {
                  "source": "app-footer-amp-style",
                  "translation": "width: 119px; height: 57px"
              },
              {
                  "source": "app-footer-funded-by",
                  "translation": "Funded By"
              },
              {
                  "source": "app-footer-yess-src",
                  "translation": "https://www.mentoringcanada.ca/assets/partner-logos/YESS-funding-recognition-and-Wordmark_Ca-en.png"
              },
              {
                  "source": "app-footer-yess-alt",
                  "translation": "Funded by the Government of Canada's Youth Employment Skills Strategy"
              },
              {
                  "source": "app-footer-yess-style",
                  "translation": "width: 261px; height: 40px"
              },
              {
                  "source": "app-footer-bmo-src",
                  "translation": "https://www.mentoringcanada.ca/assets/partner-logos/BMO_TK_E_White.png"
              },
              {
                  "source": "app-footer-bmo-alt",
                  "translation": "BMO Bank of Montreal"
              },
              {
                  "source": "app-footer-bmo-style",
                  "translation": "width: 108px; height: 40px"
              },
              {
                  "source": "app-footer-home",
                  "translation": "Home"
              },
              {
                  "source": "app-footer-privacy-policy",
                  "translation": "Privacy Policy"
              },
              {
                  "source": "app-footer-privacy-policy-link",
                  "translation": "https://www.mentoring.org/privacy-policy/"
              },
              {
                  "source": "app-footer-term-of-use",
                  "translation": "Terms of Use"
              },
              {
                  "source": "app-footer-terms-of-use-link",
                  "translation": "https://www.mentoring.org/terms-of-service/"
              },
              {
                  "source": "app-footer-terms-of-use-moodle",
                  "translation": "Online Mentor Orientation Terms of Use"
              },
              {
                  "source": "app-footer-terms-of-use-moodle-link",
                  "translation": "https://www.mentoringcanada.ca/en/online-mentor-orientation-terms-of-use"
              },
              {
                  "source": "app-footer-terms-of-use",
                  "translation": "Terms of Service"
              },
              {
                  "source": "app-program-delivery",
                  "translation": "Program Delivery"
              },
              {
                  "source": "app-program-physical-locations-label",
                  "translation": "Program Locations"
              },
              {
                  "source": "app-program-e-mentoring-locations-label",
                  "translation": "Program Areas of Service"
              },
              {
                  "source": "app-program-physical-locations-description",
                  "translation": "Please enter the locations where this program is offered, and select from the suggestions in the dropdown list below. Search for addresses or place names, and add multiple places if this program is offered at multiple locations."
              },
              {
                  "source": "app-program-e-mentoring-locations-description",
                  "translation": "Please enter the areas of service where this program is offered, and select from the suggestions in the dropdown list below. Search for boroughs, cities, states or other areas, and add multiple ones if this program is offered in multiple areas."
              },
              {
                  "source": "app-program-is-delivered-how",
                  "translation": "How is this program delivered?"
              },
              {
                  "source": "app-program-delivery-physical",
                  "translation": "Program offered in person at physical locations and / or in the community"
              },
              {
                  "source": "app-program-delivery-e-mentoring",
                  "translation": "E-mentoring"
              },
              {
                  "source": "app-created-ago",
                  "translation": "${date} ago"
              },
              {
                  "source": "app-add-new-administrator",
                  "translation": "Add a new administrator to '${title}'"
              },
              {
                  "source": "app-add-organization-contact-as-administrator",
                  "translation": "Add the organization contact person as an administrator"
              },
              {
                  "source": "app-complete-registration",
                  "translation": "Complete your registration"
              },
              {
                  "source": "app-edit-organization-settings",
                  "translation": "Edit organization settings"
              },
              {
                  "source": "app-email-reference-tip",
                  "translation": "Start typing an email, and select an existing one or add a new one as an administrator."
              },
              {
                  "source": "app-hi",
                  "translation": "Hi"
              },
              {
                  "source": "app-new-account-message",
                  "translation": "to edit its settings."
              },
              {
                  "source": "app-new-administrator-message",
                  "translation": "You are now an administrator of '@title' organization."
              },
              {
                  "source": "app-field-alt-phone",
                  "translation": "Alt Phone"
              },
              {
                  "source": "app-field-description",
                  "translation": "Description"
              },
              {
                  "source": "app-field-display-title",
                  "translation": "Display Title"
              },
              {
                  "source": "app-field-email",
                  "translation": "Email"
              },
              {
                  "source": "app-field-first-name",
                  "translation": "First Name"
              },
              {
                  "source": "app-field-has-location",
                  "translation": "Has Location"
              },
              {
                  "source": "app-field-last-name",
                  "translation": "Last Name"
              },
              {
                  "source": "app-field-legal-name",
                  "translation": "Legal Name"
              },
              {
                  "source": "app-field-phone",
                  "translation": "Phone"
              },
              {
                  "source": "app-field-physical-location",
                  "translation": "Physical Location"
              },
              {
                  "source": "app-field-position",
                  "translation": "Position"
              },
              {
                  "source": "app-field-position-other",
                  "translation": "Position other"
              },
              {
                  "source": "app-field-session",
                  "translation": "Session"
              },
              {
                  "source": "app-field-standing",
                  "translation": "Standing"
              },
              {
                  "source": "app-field-fax-status",
                  "translation": "Tax status"
              },
              {
                  "source": "app-field-fax-status-other",
                  "translation": "Tax status other"
              },
              {
                  "source": "app-field-type",
                  "translation": "Type"
              },
              {
                  "source": "app-field-type-other",
                  "translation": "Type other"
              },
              {
                  "source": "app-field-web-address",
                  "translation": "Web address"
              },
              {
                  "source": "app-add-user-add",
                  "translation": "Add"
              },
              {
                  "source": "app-add-user-as-an-administrator",
                  "translation": "as an administrator"
              },
              {
                  "source": "app-add-user-no-matches",
                  "translation": "No matches found, please type in a valid email"
              },
              {
                  "source": "app-add-organization-contact-as-administrator-pre",
                  "translation": "Add the organization's contact person"
              },
              {
                  "source": "app-add-organization-contact-as-administrator-post",
                  "translation": "as an administrator. This will immediately send the user an email."
              },
              {
                  "source": "app-add-organization-contact-as-administrator-button",
                  "translation": "Add the organization contact"
              },
              {
                  "source": "app-add-organization-new-administrator",
                  "translation": "Add a new administrator to '${title}'"
              },
              {
                  "source": "app-add-organization-new-administrator-pre",
                  "translation": "Add a new administrator to"
              },
              {
                  "source": "app-add-organization-new-administrator-post",
                  "translation": "This will immediately send the user an email."
              },
              {
                  "source": "app-add-organization-new-administrator-button",
                  "translation": "Add a new administrator"
              },
              {
                  "source": "app-organization-administrators",
                  "translation": "Organization Administrators"
              },
              {
                  "source": "app-organization-administrators-no-results",
                  "translation": "No administrators have been added for this organization"
              },
              {
                  "source": "app-password",
                  "translation": "Password"
              },
              {
                  "source": "app-password-confirm",
                  "translation": "Confirm Password"
              },
              {
                  "source": "app-continue",
                  "translation": "Continue"
              },
              {
                  "source": "app-contact-details",
                  "translation": "Contact Details"
              },
              {
                  "source": "app-search-program-criteria",
                  "translation": "What program criteria are you looking for?"
              },
              {
                  "source": "app-search-distance-willing-to-travel",
                  "translation": "What distance are you willing to travel?"
              },
              {
                  "source": "app-search-tell-us-more-about-how-you-heard-about-us",
                  "translation": "Tell us more about how you heard about us"
              },
              {
                  "source": "app-search-results",
                  "translation": "Find the mentoring opportunity that is right for you!"
              },
              {
                  "source": "app-focus-area",
                  "translation": "Focus Area"
              },
              {
                  "source": "app-ages",
                  "translation": "Ages"
              },
              {
                  "source": "app-mentoring-type",
                  "translation": "Mentoring Type"
              },
              {
                  "source": "app-search-again",
                  "translation": "Search Again"
              },
              {
                  "source": "app-field-administrators",
                  "translation": "Administrators"
              },
              {
                  "source": "app-field-display-tittle",
                  "translation": "Title"
              },
              {
                  "source": "app-field-employee-id",
                  "translation": "Employee ID"
              },
              {
                  "source": "app-field-external-id",
                  "translation": "External ID"
              },
              {
                  "source": "app-field-facebook",
                  "translation": "Facebook"
              },
              {
                  "source": "app-field-facility",
                  "translation": "Facility"
              },
              {
                  "source": "app-field-facility-other",
                  "translation": "Facility other"
              },
              {
                  "source": "app-field-focus-area",
                  "translation": "Focus area"
              },
              {
                  "source": "app-field-focus-area-other",
                  "translation": "Focus area other"
              },
              {
                  "source": "app-field-instagram",
                  "translation": "Instagram"
              },
              {
                  "source": "app-field-mentor-role-description",
                  "translation": "Mentor role description"
              },
              {
                  "source": "app-field-number-of-locations",
                  "translation": "Number of locations"
              },
              {
                  "source": "app-field-organization-entity",
                  "translation": "Organization entity"
              },
              {
                  "source": "app-field-physical-locations",
                  "translation": "Physical locations"
              },
              {
                  "source": "app-field-primary-loc-other",
                  "translation": "Primary meeting location other"
              },
              {
                  "source": "app-field-primary-meeting-location",
                  "translation": "Primary meeting location"
              },
              {
                  "source": "app-field-program-administrator-cont",
                  "translation": "Program administrator contact"
              },
              {
                  "source": "app-field-program-administrator-name",
                  "translation": "Program administrator name"
              },
              {
                  "source": "app-field-program-administrator-role",
                  "translation": "Program administrator role"
              },
              {
                  "source": "app-field-program-age-mentor-other",
                  "translation": "Program mentor age other"
              },
              {
                  "source": "app-field-program-ages-mentor-target",
                  "translation": "Program target mentor ages"
              },
              {
                  "source": "app-field-program-ages-other",
                  "translation": "Program ages other"
              },
              {
                  "source": "app-field-program-ages-served",
                  "translation": "Program ages served"
              },
              {
                  "source": "app-field-program-beginning-and-end",
                  "translation": "Program has beginning and end"
              },
              {
                  "source": "app-field-program-delivery",
                  "translation": "Program delivery"
              },
              {
                  "source": "app-field-program-family-other",
                  "translation": "Program family structures served other"
              },
              {
                  "source": "app-field-program-family-served",
                  "translation": "Program family structures served "
              },
              {
                  "source": "app-field-program-gender-mentor-other",
                  "translation": "Program target mentor gender other"
              },
              {
                  "source": "app-field-program-gender-mentor-target",
                  "translation": "Program target mentor genders"
              },
              {
                  "source": "app-field-program-genders-other",
                  "translation": "Program genders served other"
              },
              {
                  "source": "app-field-program-genders-served",
                  "translation": "Program genders served"
              },
              {
                  "source": "app-field-program-has-specific-goals",
                  "translation": "Program has specific goals"
              },
              {
                  "source": "app-field-program-how-are-meetings-s",
                  "translation": "Program how are meetings scheduled"
              },
              {
                  "source": "app-field-program-how-other",
                  "translation": "Program how other"
              },
              {
                  "source": "app-field-program-matches-explain",
                  "translation": "Program explain how matches are made"
              },
              {
                  "source": "app-field-program-matches-how",
                  "translation": "Program how are matches made"
              },
              {
                  "source": "app-field-program-mentees-waiting-li",
                  "translation": "Program how many mentees on waiting list"
              },
              {
                  "source": "app-field-program-mentor-freq-commit",
                  "translation": "Program mentor frequency commitment"
              },
              {
                  "source": "app-field-program-mentor-freq-other",
                  "translation": "Program mentor frequency commitment other"
              },
              {
                  "source": "app-field-program-mentor-hour-commit",
                  "translation": "Program mentor hourly commitment"
              },
              {
                  "source": "app-field-program-mentor-hour-other",
                  "translation": "Program mentor hourly commitment other"
              },
              {
                  "source": "app-field-program-mentor-month-commit",
                  "translation": "Program mentor monthly commitment"
              },
              {
                  "source": "app-field-program-mentor-month-other",
                  "translation": "Program mentor month other"
              },
              {
                  "source": "app-field-program-must-train-mentees",
                  "translation": "Program mentee training mandatory"
              },
              {
                  "source": "app-field-program-must-train-mentors",
                  "translation": "Program mentor training mandatory"
              },
              {
                  "source": "app-field-program-ongoing-support",
                  "translation": "Program provides ongoing support"
              },
              {
                  "source": "app-field-program-operated-other",
                  "translation": "Program operated through other"
              },
              {
                  "source": "app-field-program-operated-through",
                  "translation": "Program operated through"
              },
              {
                  "source": "app-field-program-screens-mentees",
                  "translation": "Program screens mentees"
              },
              {
                  "source": "app-field-program-screens-mentees-how",
                  "translation": "Program screens mentees how"
              },
              {
                  "source": "app-field-program-screens-mentors",
                  "translation": "Program screens mentors"
              },
              {
                  "source": "app-field-program-screens-mentors-how",
                  "translation": "Program screens mentors how"
              },
              {
                  "source": "app-field-program-trains-mentees",
                  "translation": "Program trains mentees"
              },
              {
                  "source": "app-field-program-trains-mentees-how",
                  "translation": "Program trains mentees how"
              },
              {
                  "source": "app-field-program-trains-mentors",
                  "translation": "Program trains mentors"
              },
              {
                  "source": "app-field-program-trains-mentors-how",
                  "translation": "Program trains mentors how"
              },
              {
                  "source": "app-field-program-types-of-mentoring-other",
                  "translation": "Program types of mentoring other"
              },
              {
                  "source": "app-field-program-which-goals",
                  "translation": "Program specific goals"
              },
              {
                  "source": "app-field-program-which-goals-other",
                  "translation": "Program specific goals other"
              },
              {
                  "source": "app-field-program-youth-other",
                  "translation": "Program youth served other"
              },
              {
                  "source": "app-field-program-youth-per-year",
                  "translation": "Program youth per year"
              },
              {
                  "source": "app-field-program-youth-served",
                  "translation": "Program youth served"
              },
              {
                  "source": "app-field-twitter",
                  "translation": "Twitter"
              },
              {
                  "source": "app-field-types-of-mentoring",
                  "translation": "Types of mentoring"
              },
              {
                  "source": "app-field-virtual",
                  "translation": "Virtual"
              },
              {
                  "source": "app-field-website",
                  "translation": "Website"
              },
              {
                  "source": "app-us-results-subheadline",
                  "translation": "There are ${count} programs matching your criteria within ${distance} miles."
              },
              {
                  "source": "app-us-results-subheadline-singular",
                  "translation": "There is ${count} program matching your criteria within ${distance} miles."
              },
              {
                  "source": "app-ca-results-subheadline",
                  "translation": "There are ${count} programs matching your criteria within ${distance} kilometers."
              },
              {
                  "source": "app-ca-results-subheadline-singular",
                  "translation": "There is ${count} program matching your criteria within ${distance} kilometers."
              },
              {
                  "source": "app-ca-distance-unit",
                  "translation": "km"
              },
              {
                  "source": "app-us-distance-unit",
                  "translation": "mi"
              },
              {
                  "source": "app-distance-away",
                  "translation": "away"
              },
              {
                  "source": "app-back-to-search-results",
                  "translation": "Back to Search Results"
              },
              {
                  "source": "app-program-apply",
                  "translation": "Program Details"
              },
              {
                  "source": "app-apply-to-program",
                  "translation": "Inquire with this program"
              },
              {
                  "source": "app-application",
                  "translation": "Thank you!"
              },
              {
                  "source": "app-email-application-admin-submited-receipt",
                  "translation": "New Application for @programTitle"
              },
              {
                  "source": "app-email-application-admin-notification-paragraph-1",
                  "translation": "@firstName @lastName has applied as a @applicantRole to '@programTitle'."
              },
              {
                  "source": "app-email-application-admin-notification-paragraph-2",
                  "translation": "To contact them back, please reply directly to this email, or use the link below to send and email."
              },
              {
                  "source": "app-email-application-admin-notification-email",
                  "translation": "Send an email to this contact"
              },
              {
                  "source": "app-email-application-submited-receipt",
                  "translation": "Thank you for contacting @programTitle!"
              },
              {
                  "source": "app-email-application-notification-paragraph-1",
                  "translation": "Thank you for your interest in becoming a @applicantRole with @programTitle."
              },
              {
                  "source": "app-email-application-notification-paragraph-2",
                  "translation": "You should receive a follow-up email from us shortly."
              },
              {
                  "source": "app-table-admins",
                  "translation": "Administrators"
              },
              {
                  "source": "app-table-approval",
                  "translation": "Approval"
              },
              {
                  "source": "app-organization-administrators-approval",
                  "translation": "Administration of the '${organizationName}' Organization"
              },
              {
                  "source": "app-organization-administrators-description",
                  "translation": "Add administrators for this organization. Please note that adding an administrator will immediately send the user an email; if they already have an account in the Mentoring Connector they will be notified, and if not an account will be created for them and they will be invited to complete their registration."
              },
              {
                  "source": "app-review-organization-approval",
                  "translation": "Organization Approval"
              },
              {
                  "source": "app-review-organization-administrators",
                  "translation": "Organization Administrators"
              },
              {
                  "source": "app-organization-approval",
                  "translation": "Organization Approval"
              },
              {
                  "source": "app-program-administrators-approval",
                  "translation": "Administration of the '${programName}' Program"
              },
              {
                  "source": "app-program-administrators-description",
                  "translation": "Add administrators for this program. Please note that adding an administrator will immediately send the user an email; if they already have an account in the Mentoring Connector they will be notified, and if not an account will be created for them and they will be invited to complete their registration."
              },
              {
                  "source": "app-add-program-contact-as-administrator",
                  "translation": "Add the program contact person as an administrator"
              },
              {
                  "source": "app-add-program-contact-as-administrator-button",
                  "translation": "Add the program contact"
              },
              {
                  "source": "app-add-program-contact-as-administrator-pre",
                  "translation": "Add the program's contact person"
              },
              {
                  "source": "app-add-program-contact-as-administrator-post",
                  "translation": "as an administrator. This will immediately send the user an email."
              },
              {
                  "source": "app-add-program-new-administrator",
                  "translation": "Add a new administrator to '${title}'"
              },
              {
                  "source": "app-add-program-new-administrator-button",
                  "translation": "Add a new administrator"
              },
              {
                  "source": "app-add-program-new-administrator-pre",
                  "translation": "Add a new administrator to"
              },
              {
                  "source": "app-add-program-new-administrator-post",
                  "translation": "This will immediately send the user an email."
              },
              {
                  "source": "app-review-program-approval",
                  "translation": "Program Approval"
              },
              {
                  "source": "app-review-program-administrators",
                  "translation": "Program Administrators"
              },
              {
                  "source": "app-program-administrators",
                  "translation": "Program Administrators"
              },
              {
                  "source": "app-program-approval",
                  "translation": "Program Approval"
              },
              {
                  "source": "app-program-administrators-no-results",
                  "translation": "No administrators have been added for this program"
              },
              {
                  "source": "app-invalid-username-or-password",
                  "translation": "Invalid username or password"
              },
              {
                  "source": "app-mentor",
                  "translation": "Mentor"
              },
              {
                  "source": "app-mentee",
                  "translation": "Mentee"
              },
              {
                  "source": "app-contacted",
                  "translation": "Contacted"
              },
              {
                  "source": "app-email-administrator-support-message",
                  "translation": "If you have any questions or need support please contact"
              },
              {
                  "source": "app-email-new-organization-administrator-existing-admin-message-1",
                  "translation": "Congratulations, you are now an Administrator of '@title' organization. Your organization has been approved in Mentoring Connector. Please click on the link below to review and edit the organization settings."
              },
              {
                  "source": "app-email-new-organization-administrator-existing-admin-message-2",
                  "translation": "You can also click on the link below to submit your mentoring program(s) for approval and to be listed publicly in Mentoring Connector."
              },
              {
                  "source": "app-email-new-organization-administrator-existing-admin-organization-link",
                  "translation": "Review and edit organization settings"
              },
              {
                  "source": "app-email-new-organization-administrator-existing-admin-programs-link",
                  "translation": "Add programs for your organization"
              },
              {
                  "source": "app-email-new-organization-administrator-heading",
                  "translation": "'@title' Administration"
              },
              {
                  "source": "app-email-new-organization-administrator-new-admin-message-1",
                  "translation": "Congratulations, you are now an Administrator of '@title' organization. As the Administrator you can review and edit this organization's settings. Since this is your first time using Mentoring Connector, you will be asked to complete your registration. Please click on the link below to review and edit the organization settings."
              },
              {
                  "source": "app-email-new-organization-administrator-new-admin-message-2",
                  "translation": "You can also click on the link below to submit your mentoring program(s) for approval and to be listed publicly in Mentoring Connector."
              },
              {
                  "source": "app-email-new-organization-administrator-new-admin-organization-link",
                  "translation": "Complete your registration to review and edit organization settings"
              },
              {
                  "source": "app-email-new-organization-administrator-new-admin-programs-link",
                  "translation": "Complete your registration and add programs for your organization"
              },
              {
                  "source": "app-email-new-program-administrator-existing-admin-message-1",
                  "translation": "Congratulations, you are now an Administrator of '@title' program. Your program has been approved in Mentoring Connector. Please click on the link below to review and edit the program settings."
              },
              {
                  "source": "app-email-new-program-administrator-existing-admin-program-link",
                  "translation": "Review and edit program settings"
              },
              {
                  "source": "app-email-new-program-administrator-heading",
                  "translation": "'@title' Administration"
              },
              {
                  "source": "app-email-new-program-administrator-new-admin-message-1",
                  "translation": "Congratulations, you are now an Administrator of '@title' program. As the Administrator you can review and edit this program's settings. Since this is your first time using Mentoring Connector, you will be asked to complete your registration. Please click on the link below to review and edit the program settings."
              },
              {
                  "source": "app-email-new-program-administrator-new-admin-program-link",
                  "translation": "Complete your registration to review and edit program settings"
              },
              {
                  "source": "app-feedback-label",
                  "translation": "Feedback"
              },
              {
                  "source": "app-feedback-legend",
                  "translation": "Please tell us what we can improve in this process"
              },
              {
                  "source": "app-partner",
                  "translation": "Partner"
              },
              {
                  "source": "app-postal-zip-code",
                  "translation": "Postal / ZIP Code"
              },
              {
                  "source": "app-program",
                  "translation": "Program"
              },
              {
                  "source": "app-role",
                  "translation": "Role"
              },
              {
                  "source": "app-un-contacted",
                  "translation": "Uncontacted"
              },
              {
                  "source": "app-Spanish",
                  "translation": "Español"
              },
              {
                  "source": "app-access-denied",
                  "translation": "Access Denied"
              },
              {
                  "source": "app-active",
                  "translation": "Active"
              },
              {
                  "source": "app-add-new-administrator-no-title",
                  "translation": "Add a new administrator"
              },
              {
                  "source": "app-add-user-invitation-pending",
                  "translation": "Invitation Pending"
              },
              {
                  "source": "app-blocked",
                  "translation": "Blocked"
              },
              {
                  "source": "app-ca-place-picker-hint",
                  "translation": "Please type in your location, including your city, province, and postal code, and select from the suggestions in the dropdown list below."
              },
              {
                  "source": "app-current-status",
                  "translation": "Current Status"
              },
              {
                  "source": "app-email-organization-ready-heading",
                  "translation": "Organization Approved"
              },
              {
                  "source": "app-email-organization-ready-message-1",
                  "translation": "Your organization has been approved in Mentoring Connector. You can click on the link below to submit your mentoring program(s) for approval and to be listed publicly in Mentoring Connector."
              },
              {
                  "source": "app-field-distance",
                  "translation": "Distance"
              },
              {
                  "source": "app-field-focus",
                  "translation": "Focus"
              },
              {
                  "source": "app-field-global-administrator",
                  "translation": "Global Admin"
              },
              {
                  "source": "app-field-how-did-you-hear-about-us",
                  "translation": "How did you hear about us"
              },
              {
                  "source": "app-field-id",
                  "translation": "ID"
              },
              {
                  "source": "app-field-partner-entity",
                  "translation": "Partner Entity"
              },
              {
                  "source": "app-field-partner-id",
                  "translation": "Partner ID"
              },
              {
                  "source": "app-field-program",
                  "translation": "Program"
              },
              {
                  "source": "app-field-role",
                  "translation": "Role"
              },
              {
                  "source": "app-field-search",
                  "translation": "Search"
              },
              {
                  "source": "app-field-status",
                  "translation": "Status"
              },
              {
                  "source": "app-field-type-of-mentoring",
                  "translation": "Type of Mentoring"
              },
              {
                  "source": "app-field-youth",
                  "translation": "Youth"
              },
              {
                  "source": "app-field-youth-age",
                  "translation": "Age"
              },
              {
                  "source": "app-field-zip",
                  "translation": "Zip"
              },
              {
                  "source": "app-inquiries",
                  "translation": "Inquiries"
              },
              {
                  "source": "app-invite-organization-contact-to-add-programs",
                  "translation": "Invite the organization contact person to add programs"
              },
              {
                  "source": "app-invite-organization-contact-to-add-programs-button",
                  "translation": "Invite the organization contact to add programs"
              },
              {
                  "source": "app-invite-organization-contact-to-add-programs-post",
                  "translation": "to add programs for this organization. This will immediately send the user an email."
              },
              {
                  "source": "app-invite-organization-contact-to-add-programs-pre",
                  "translation": "Invite the organization's contact person"
              },
              {
                  "source": "app-invite-organization-contact-to-add-programs-sent",
                  "translation": "Approval Email Sent"
              },
              {
                  "source": "app-invite-organization-contact-to-add-programs-sent-post",
                  "translation": "to the contact person at that time inviting them to add programs for this organization."
              },
              {
                  "source": "app-invite-organization-contact-to-add-programs-sent-pre",
                  "translation": "An approval email was sent at"
              },
              {
                  "source": "app-organization-approval-email-sent",
                  "translation": "Sent"
              },
              {
                  "source": "app-radios-required-tip",
                  "translation": "Select one of the options below."
              },
              {
                  "source": "app-table-inquiries-empty",
                  "translation": "No Inquiries Found"
              },
              {
                  "source": "app-30-km",
                  "translation": "30 kilometres"
              },
              {
                  "source": "app-add-region",
                  "translation": "Add Affiliate"
              },
              {
                  "source": "app-ages-served",
                  "translation": "Ages Served"
              },
              {
                  "source": "app-app",
                  "translation": "App"
              },
              {
                  "source": "app-click-here-to-submit-it",
                  "translation": "Click here to submit it."
              },
              {
                  "source": "app-coming-soon",
                  "translation": "Coming Soon"
              },
              {
                  "source": "app-compact-search-branding",
                  "translation": "Search results are provided by the Mentor Connector database, powered by"
              },
              {
                  "source": "app-compact-search-placeholder",
                  "translation": "Enter your postal code"
              },
              {
                  "source": "app-contact",
                  "translation": "Contact"
              },
              {
                  "source": "app-dont-see-your-program",
                  "translation": "<h3>Do you know of a mentoring program that isn't listed in your search results?</h3><p>Getting listed in the Mentoring Connector is free. <a href='mailto:connector@mentoring.org'>Send us an email</a>, and we will reach out to them, or, you can invite them to submit an organization or program <a href='/en/programs/add/step/1'>here</a>.</p>"
              },
              {
                  "source": "app-edit-partner",
                  "translation": "Edit Partner"
              },
              {
                  "source": "app-edit-region",
                  "translation": "Edit Affiliate"
              },
              {
                  "source": "app-family-structures-served",
                  "translation": "Family Structures Served"
              },
              {
                  "source": "app-genders-served",
                  "translation": "Genders Served"
              },
              {
                  "source": "app-i-have-read-and-agree-to-the",
                  "translation": "I have read and agree to the"
              },
              {
                  "source": "app-invitation-sent",
                  "translation": "<p>An invitation to the e-mentoring platform has been sent for '${invite_tenant_name}'. The invitation was sent to ${invite_first_name} ${invite_last_name} (<a href='mailto:${invite_email}'>${invite_email}</a>) at the request of ${sent_by_first_name} ${sent_by_last_name} (<a href='${sent_by_email}'>${sent_by_email}</a>) on ${dateString}.</p><p>If an email from Mentor To Go isn't received at <a href='mailto:${invite_email}'>${invite_email}</a>, please ensure it wasn’t sent to junk/spam, and if it isn’t there, then visit <a href='https://support.mentoringcanada.ca' target='blank'>support.mentoringcanada.ca</a> for assistance.</p>"
              },
              {
                  "source": "app-locations",
                  "translation": "Locations"
              },
              {
                  "source": "app-meeting-area",
                  "translation": "Meeting Area"
              },
              {
                  "source": "app-program-accepting-mentees",
                  "translation": "Mentees"
              },
              {
                  "source": "app-program-accepting-mentors",
                  "translation": "Mentors"
              },
              {
                  "source": "app-program-focus",
                  "translation": "Program Focus"
              },
              {
                  "source": "app-program-status",
                  "translation": "Currently Accepting"
              },
              {
                  "source": "app-request-access-to-e-mentoring-platform",
                  "translation": "Request Access to the E-Mentoring-Platform"
              },
              {
                  "source": "app-results-html",
                  "translation": "<p>Mentoring programs are incredibly diverse. Some offer different activities and are targeted to different age groups. Some take place in groups or teams while others focus on individual relationships. Take a look at the following programs available in your area or search based on different criteria best suited to meet your needs and interests.</p>"
              },
              {
                  "source": "app-server",
                  "translation": "Server"
              },
              {
                  "source": "app-types-of-mentoring",
                  "translation": "Types of Mentoring"
              },
              {
                  "source": "app-view-full-program-details",
                  "translation": "View Full Program Details"
              },
              {
                  "source": "app-ca-place-picker-invalid",
                  "translation": "Please select from the suggestions in the dropdown list below."
              },
              {
                  "source": "app-program-status-description",
                  "translation": "Ready to recruit mentors or mentees? Make sure to click on these boxes. This can be changed as needed if you are no longer recruiting."
              },
              {
                  "source": "app-50-km",
                  "translation": "50 kilometres"
              },
              {
                  "source": "app-75-km",
                  "translation": "75 kilometres"
              },
              {
                  "source": "app-100-km",
                  "translation": "100 kilometres"
              },
              {
                  "source": "app-feedback-cta",
                  "translation": "Tell us about your experience"
              },
              {
                  "source": "app-province",
                  "translation": "State"
              },
              {
                  "source": "app-unknown",
                  "translation": "Unknown"
              },
              {
                  "source": "app-without-physical-location",
                  "translation": "No Physical Address"
              },
              {
                  "source": "app-integrations",
                  "translation": "Integrations"
              },
              {
                  "source": "app-mentor-to-go",
                  "translation": "Mentor To Go"
              },
              {
                  "source": "app-notify",
                  "translation": "Notify"
              },
              {
                  "source": "app-notify-cta",
                  "translation": "<h3>Don't see the opportunity that is the right fit for you?</h3><p>New results are added on a regular basis. We'll let you know when a new one becomes available.</p>"
              },
              {
                  "source": "app-notify-new-programs",
                  "translation": "Notify me"
              },
              {
                  "source": "app-notify-submitted-body",
                  "translation": "We'll follow-up with you by email."
              },
              {
                  "source": "app-notify-submitted-headline",
                  "translation": "Thank you for supporting mentoring in your community."
              },
              {
                  "source": "app-ok",
                  "translation": "Ok"
              },
              {
                  "source": "app-admin-add-partner",
                  "translation": "Add Partner"
              },
              {
                  "source": "app-e-mentoring-logo-content",
                  "translation": "<b>Optional:</b> Add your logo for use within the E-Mentoring-Platform."
              },
              {
                  "source": "app-e-mentoring-logo-tip",
                  "translation": "For best results please upload a 300 x 300 pixel image."
              },
              {
                  "source": "app-e-mentoring-logo-title",
                  "translation": "Optional Logo"
              },
              {
                  "source": "app-home",
                  "translation": "Home"
              },
              {
                  "source": "app-languages",
                  "translation": "Languages"
              },
              {
                  "source": "app-logo",
                  "translation": "Logo"
              },
              {
                  "source": "app-network-error",
                  "translation": "An error occured."
              },
              {
                  "source": "app-request-access",
                  "translation": "Request Access"
              },
              {
                  "source": "app-settings",
                  "translation": "Settings"
              },
              {
                  "source": "app-accepting",
                  "translation": "Accepting"
              },
              {
                  "source": "app-available-service-areas",
                  "translation": "Available Service Areas"
              },
              {
                  "source": "app-city",
                  "translation": "City"
              },
              {
                  "source": "app-county",
                  "translation": "County"
              },
              {
                  "source": "app-dashboard",
                  "translation": "Dashboard"
              },
              {
                  "source": "app-e-mentoring-email-subject",
                  "translation": "E-Mentoring-Platform Request"
              },
              {
                  "source": "app-mtg-request-email",
                  "translation": "<p>@sent_by_first_name @sent_by_last_name has sent in a request for @invite_tenant_name to be granted access to the Mentor To Go e-mentoring system with you as the administrator for that system. Expect an email with a link for you to follow to onboard your organization to that platform.</p><p>If in a while you still haven't received that onboarding email, please check your spam folder, and if it’s not there, please visit <a href='https://support.mentoringcanada.ca'>support.mentoringcanada.ca</a> for assistance.</p>"
              },
              {
                  "source": "app-request-access-to-e-mentoring-platform-body",
                  "translation": "Please enter the information for the person who will be the administrator of the e-mentoring platform for your organization."
              },
              {
                  "source": "app-selected-service-areas",
                  "translation": "Selected Service Areas"
              },
              {
                  "source": "app-service-areas",
                  "translation": "Service Areas"
              },
              {
                  "source": "app-service-areas-edit-description",
                  "translation": "Enter all zip codes in your affiliate's service area using the tool below. Under Available Service Areas, enter your State and City or County to narrow down the list of zip codes, then click the +Add Area button beside each zip code in your service area. When you're finished, all of the zip codes your affiliate serves should be listed under Selected Service Areas."
              },
              {
                  "source": "app-state",
                  "translation": "State"
              },
              {
                  "source": "app-zip",
                  "translation": "Zip"
              },
              {
                  "source": "app-last-180-days",
                  "translation": "Last 180 days"
              },
              {
                  "source": "app-last-30-days",
                  "translation": "Last 30 days"
              },
              {
                  "source": "app-last-365-days",
                  "translation": "Last 365 days"
              },
              {
                  "source": "app-last-7-days",
                  "translation": "Last 7 days"
              },
              {
                  "source": "app-last-90-days",
                  "translation": "Last 90 days"
              },
              {
                  "source": "app-resource-library",
                  "translation": "Resource Library"
              },
              {
                  "source": "app-total",
                  "translation": "Total"
              },
              {
                  "source": "app-uncontacted",
                  "translation": "Uncontacted"
              },
              {
                  "source": "app-program-logo",
                  "translation": "Logo"
              },
              {
                  "source": "app-last-0-days",
                  "translation": "Today"
              },
              {
                  "source": "app-last-1-days",
                  "translation": "Yesterday"
              },
              {
                  "source": "app-give-feedback",
                  "translation": "Tell us about your experience"
              },
              {
                  "source": "app-give-feedback-heading",
                  "translation": "Tell us about your experience"
              },
              {
                  "source": "app-give-feedback-message",
                  "translation": "Let us know what you're thinking and what we can do to improve your experience."
              },
              {
                  "source": "app-address-1",
                  "translation": "201 South Street, Suite 615"
              },
              {
                  "source": "app-address-2",
                  "translation": "Boston, MA 02111"
              },
              {
                  "source": "app-address-name",
                  "translation": "MENTOR National"
              },
              {
                  "source": "app-facebook-link",
                  "translation": "https://www.facebook.com/MENTORnational"
              },
              {
                  "source": "app-instagram-link",
                  "translation": "https://www.instagram.com/MentorNMP/"
              },
              {
                  "source": "app-linkedin-link",
                  "translation": "https://www.linkedin.com/company/mentornational-mentoring-partnership/"
              },
              {
                  "source": "app-twitter-link",
                  "translation": "https://twitter.com/MENTORnational"
              },
              {
                  "source": "app-youtube-link",
                  "translation": "https://www.youtube.com/user/mentoringorg"
              },
              {
                  "source": "app-additional",
                  "translation": "Additional"
              },
              {
                  "source": "app-admin-logged-in",
                  "translation": "Mentoring Connector Administration"
              },
              {
                  "source": "app-admin-not-logged-in",
                  "translation": "Sign In to Mentoring Connector"
              },
              {
                  "source": "app-duplicate-email-body",
                  "translation": "This email address is already in use by another user."
              },
              {
                  "source": "app-duplicate-email-heading",
                  "translation": "Duplicate Email"
              },
              {
                  "source": "app-e-mentoring-service-area",
                  "translation": "Service Area"
              },
              {
                  "source": "app-get-new-link",
                  "translation": "Reset your password to continue."
              },
              {
                  "source": "app-grade-6-8",
                  "translation": "6-8"
              },
              {
                  "source": "app-grade-9-12",
                  "translation": "9-12"
              },
              {
                  "source": "app-grade-k-5",
                  "translation": "K-5"
              },
              {
                  "source": "app-grades",
                  "translation": "Grades"
              },
              {
                  "source": "app-grades-served",
                  "translation": "Grades Served"
              },
              {
                  "source": "app-national-e-mentoring-programs",
                  "translation": "Nationwide e-mentoring"
              },
              {
                  "source": "app-nationwide",
                  "translation": "National"
              },
              {
                  "source": "app-okay",
                  "translation": "okay"
              },
              {
                  "source": "app-password-reset-success-heading",
                  "translation": "Your password has been successfully reset"
              },
              {
                  "source": "app-program-grade-program-serves",
                  "translation": "Grade(s) program serves"
              },
              {
                  "source": "app-reset-link-not-valid",
                  "translation": "The current link is no longer valid."
              },
              {
                  "source": "app-results-nationwide-subheadline",
                  "translation": "There are ${count} nationwide e-mentoring programs matching your criteria."
              },
              {
                  "source": "app-results-nationwide-subheadline-singular",
                  "translation": "There is ${count} nationwide e-mentoring program matching your criteria."
              },
              {
                  "source": "app-return-to",
                  "translation": "Return to"
              },
              {
                  "source": "app-search-grade-of-youth-served",
                  "translation": "Grade of Youth Served"
              },
              {
                  "source": "app-specific-service-area",
                  "translation": "Limited"
              },
              {
                  "source": "app-1-2-hours",
                  "translation": "1-2 hours"
              },
              {
                  "source": "app-1-month",
                  "translation": "1 month"
              },
              {
                  "source": "app-10-months",
                  "translation": "10 months"
              },
              {
                  "source": "app-11-months",
                  "translation": "11 months"
              },
              {
                  "source": "app-12-months-or-longer",
                  "translation": "12 months or longer"
              },
              {
                  "source": "app-2-3-hours",
                  "translation": "2-3 hours"
              },
              {
                  "source": "app-2-months",
                  "translation": "2 months"
              },
              {
                  "source": "app-3-4-hours",
                  "translation": "3-4 hours"
              },
              {
                  "source": "app-3-months",
                  "translation": "3 months"
              },
              {
                  "source": "app-3-national-standards",
                  "translation": "3 National Standards"
              },
              {
                  "source": "app-4-months",
                  "translation": "4 months"
              },
              {
                  "source": "app-5-months",
                  "translation": "5 months"
              },
              {
                  "source": "app-5-or-more-hours",
                  "translation": "5 or more hours"
              },
              {
                  "source": "app-6-months",
                  "translation": "6 months"
              },
              {
                  "source": "app-7-months",
                  "translation": "7 months"
              },
              {
                  "source": "app-8-months",
                  "translation": "8 months"
              },
              {
                  "source": "app-9-months",
                  "translation": "9 months"
              },
              {
                  "source": "app-application-submitted-paragraph",
                  "translation": "Thank you for contacting this mentoring program. If you don't receive a confirmation email, please check your spam folder and add <a href='mailto:connector@mentoring.org'>connector@mentoring.org</a> to your contacts."
              },
              {
                  "source": "app-background-check",
                  "translation": "1. Does your Program perform a background check on the mentor?"
              },
              {
                  "source": "app-background-check-fingerprint-fbi",
                  "translation": "FBI Nationwide Search"
              },
              {
                  "source": "app-background-check-fingerprint-state",
                  "translation": "State-only Search"
              },
              {
                  "source": "app-background-check-fingerprint-type",
                  "translation": "Fingerprint-based criminal background check"
              },
              {
                  "source": "app-background-check-name-local",
                  "translation": "Local-only Search"
              },
              {
                  "source": "app-background-check-name-multi-state",
                  "translation": "Multi-State Search"
              },
              {
                  "source": "app-background-check-name-state",
                  "translation": "State-only Search"
              },
              {
                  "source": "app-background-check-name-type",
                  "translation": "Name-based criminal background checks"
              },
              {
                  "source": "app-background-check-other-abuse",
                  "translation": "Child Abuse Registeries"
              },
              {
                  "source": "app-background-check-other-offender",
                  "translation": "Sexual Offender Registry"
              },
              {
                  "source": "app-background-check-other-type",
                  "translation": "Other Registries"
              },
              {
                  "source": "app-background-check-type-fingerprint",
                  "translation": "Fingerprint-based criminal background check"
              },
              {
                  "source": "app-background-check-type-name",
                  "translation": "Name-based criminal background checks"
              },
              {
                  "source": "app-background-check-type-other",
                  "translation": "Other Registries"
              },
              {
                  "source": "app-less-than-1-hour",
                  "translation": "Less than 1 hour"
              },
              {
                  "source": "app-less-than-one-month",
                  "translation": "Less than one month"
              },
              {
                  "source": "app-national",
                  "translation": "Nation Wide E-Mentoring"
              },
              {
                  "source": "app-no-minimum-match-commitment",
                  "translation": "No Minimum Match Commitment"
              },
              {
                  "source": "app-program-background-check-type",
                  "translation": "What type of background check does your Program perform on the mentor?"
              },
              {
                  "source": "app-program-mentor-training",
                  "translation": "Briefly describe the training you provide"
              },
              {
                  "source": "app-program-minimum-match",
                  "translation": "3. What is the Minimum Match Commitment between mentor-mentees at your Program?"
              },
              {
                  "source": "app-siteurl",
                  "translation": "https://mentoring.org/"
              },
              {
                  "source": "app-training",
                  "translation": "2. Does your program provide training for volunteer mentors?"
              },
              {
                  "source": "app-pagination-results-per-page",
                  "translation": "Show ${count} programs"
              },
              {
                  "source": "app-pagination-results-range",
                  "translation": "Showing ${start} — ${end} of ${total} programs"
              },
              {
                  "source": "app-search-as-i-move-the-map",
                  "translation": "Search as I move the map"
              },
              {
                  "source": "app-searching",
                  "translation": "Searching"
              },
              {
                  "source": "app-more-results-range-short",
                  "translation": "Showing ${pos} of ${total}"
              },
              {
                  "source": "app-more-results-range-long",
                  "translation": "Showing ${start} to ${end} of ${total}"
              },
              {
                  "source": "app-more-results-from-your-search",
                  "translation": "More results from your search"
              },
              {
                  "source": "app-distance-label",
                  "translation": "${distance} miles"
              },
              {
                  "source": "app-contacted-status",
                  "translation": "Contacted Status"
              },
              {
                  "source": "app-custom-date-range",
                  "translation": "Custom..."
              },
              {
                  "source": "app-email-first-steps-body",
                  "translation": "Here is @firstName @lastName's direct contact information:"
              },
              {
                  "source": "app-email-first-steps-headline",
                  "translation": "Congratulations on taking the first step!"
              },
              {
                  "source": "app-filter",
                  "translation": "Filter"
              },
              {
                  "source": "app-filter-all-time",
                  "translation": "All Time"
              },
              {
                  "source": "app-filter-last-month",
                  "translation": "Last Month"
              },
              {
                  "source": "app-filter-last-week",
                  "translation": "Last Week"
              },
              {
                  "source": "app-filter-last-year",
                  "translation": "Last Year"
              },
              {
                  "source": "app-filter-this-month",
                  "translation": "This Month"
              },
              {
                  "source": "app-filter-this-week",
                  "translation": "This Week"
              },
              {
                  "source": "app-filter-this-year",
                  "translation": "This Year"
              },
              {
                  "source": "app-hidden",
                  "translation": "Hidden"
              },
              {
                  "source": "app-inquiry-date",
                  "translation": "Inquiry Date"
              },
              {
                  "source": "app-inquiry-details",
                  "translation": "Inquiry Details"
              },
              {
                  "source": "app-mentor-or-mentee",
                  "translation": "Mentor or Mentee"
              },
              {
                  "source": "app-pick-date-range",
                  "translation": "Select Dates..."
              },
              {
                  "source": "app-program-or-saved-program-filter",
                  "translation": "Program or Saved Program Filter"
              },
              {
                  "source": "app-relay-email",
                  "translation": "Relay Email"
              },
              {
                  "source": "app-saved-filters",
                  "translation": "Saved Filters"
              },
              {
                  "source": "app-search-location",
                  "translation": "What is your search location?"
              },
              {
                  "source": "app-sms",
                  "translation": "SMS Messages"
              },
              {
                  "source": "app-table-search",
                  "translation": "No Results Found"
              },
              {
                  "source": "app-voice",
                  "translation": "Voice Calls"
              },
              {
                  "source": "app-save-filter",
                  "translation": "Save Filter"
              },
              {
                  "source": "app-has-applied-to",
                  "translation": "has applied to"
              },
              {
                  "source": "app-initial-contact",
                  "translation": "Initial contact is via email"
              },
              {
                  "source": "app-notification-requests",
                  "translation": "Notify"
              },
              {
                  "source": "app-preference",
                  "translation": "preference:"
              },
              {
                  "source": "app-lead",
                  "translation": "Lead"
              },
              {
                  "source": "app-background-check-peer-bg-check",
                  "translation": "Have all individuals over the age of 18 that supervise or participate in your Program cleared a background check in the last three years?"
              },
              {
                  "source": "app-background-check-type-peer",
                  "translation": "We are a peer-to-peer Program that involve youth only under the age of 18 and do not conduct background checks on our mentors"
              },
              {
                  "source": "app-3-national-standards-body",
                  "translation": "If your Program does not meet the following <a href='/3 National Standards Infographic.pdf' target='_blank'>3 National Standards</a>, your Affiliate or a National Admin will guide you in the direction of resources and support. Our system does not Deny any submissions; instead, your application will be temporarily Paused until your Program has met all 3 Standards and is ready to be Approved."
              },
              {
                  "source": "app-inquiry-submitted",
                  "translation": "Thank you for contacting this mentoring program. If you don't receive a confirmation email, please check your spam folder and add <a href=\"mailto:connector@mentoring.org\">connector@mentoring.org</a> to your contacts."
              },
              {
                  "source": "app-close",
                  "translation": "Close"
              },
              {
                  "source": "app-organization-filter",
                  "translation": "Organization Filter"
              },
              {
                  "source": "app-program-filter",
                  "translation": "Program Filter"
              },
              {
                  "source": "app-relationships",
                  "translation": "Relationships"
              },
              {
                  "source": "app-physical-location",
                  "translation": "Location"
              },
              {
                  "source": "app-us-18-24",
                  "translation": "18 to 24"
              },
              {
                  "source": "app-1-hour",
                  "translation": "1 hour"
              },
              {
                  "source": "app-1-2-months",
                  "translation": "1-2 months"
              },
              {
                  "source": "app-4-5-hours",
                  "translation": "4-5 hours"
              },
              {
                  "source": "app-connector-resource-library",
                  "translation": "The Mentoring Connector Resource Library"
              },
              {
                  "source": "app-connector-resource-library-description",
                  "translation": "The Mentoring Connector is the only national database of mentoring programs."
              },
              {
                  "source": "app-feedback",
                  "translation": "Feedback"
              },
              {
                  "source": "app-message",
                  "translation": "Message"
              },
              {
                  "source": "app-url",
                  "translation": "URL"
              },
              {
                  "source": "app-partner-title",
                  "translation": "Partner Title"
              },
              {
                  "source": "app-global-administrator",
                  "translation": "Global administrator"
              },
              {
                  "source": "app-others",
                  "translation": "others"
              },
              {
                  "source": "app-pyd-headline",
                  "translation": "Partners for Youth with Disabilities"
              },
              {
                  "source": "app-pyd-description",
                  "translation": "<p><strong>Online training is disability inclusive mentoring</strong></p><p>Make your program more attractive to families & volunteers by completing the Disability Mentoring Certification at <a target='_blank' href='https://learn.pyd.org'>Learn.PYD.org</a>. This online learning platform is free to mentoring program staff and features monthly webinars, online courses, and PDF resources.</p>"
              },
              {
                  "source": "app-suspended",
                  "translation": "Paused"
              },
              {
                  "source": "app-account-type",
                  "translation": "Type"
              },
              {
                  "source": "app-affiliate-administrator",
                  "translation": "Affiliate administrator"
              },
              {
                  "source": "app-organization-administrator",
                  "translation": "Organization administrator"
              },
              {
                  "source": "app-program-administrator",
                  "translation": "Program administrator"
              },
              {
                  "source": "app-program-delivery-hybrid",
                  "translation": "Hybrid"
              },
              {
                  "source": "app-clear",
                  "translation": "Clear"
              },
              {
                  "source": "app-mentor-city",
                  "translation": "MentorCity"
              },
              {
                  "source": "app-mentor-city-account-already-exists",
                  "translation": "Existing Account"
              },
              {
                  "source": "app-mentor-city-account-already-exists-body",
                  "translation": "You already have an account in MentorCity. However it isn't linked to the Mentor Connector. Please contact <a href='mailto:support@mentoringcanada.ca'>support@mentoringcanada.ca</a> for assistance."
              },
              {
                  "source": "app-mentor-city-invitation-sent",
                  "translation": "<p>An invitation to the e-mentoring platform has been sent for '${program_name}'. The invitation was sent to ${first_name} ${last_name} (<a href='mailto:${email}'>${email}</a>) at the request of ${sent_by_first_name} ${sent_by_last_name} (<a href='mailto:${sent_by_email}'>${sent_by_email}</a>) on ${dateString}.</p><p>If an email from MentorCity isn't received at <a href='mailto:${email}'>${email}</a>, please ensure it wasn’t sent to junk/spam, and if it isn’t there, then please contact <a href='mailto:support@mentoringcanada.ca'>support@mentoringcanada.ca</a> for assistance.</p>"
              },
              {
                  "source": "app-mentorcity-logo-error",
                  "translation": "An error occurred processing your logo. Please try again."
              },
              {
                  "source": "app-organization-integrations",
                  "translation": "Integrations"
              },
              {
                  "source": "app-program-delivery-community-based",
                  "translation": "Community-based"
              },
              {
                  "source": "app-program-delivery-location",
                  "translation": "Location"
              },
              {
                  "source": "app-program-delivery-site-based",
                  "translation": "Site-based"
              },
              {
                  "source": "app-program-title",
                  "translation": "Program Title"
              },
              {
                  "source": "app-request-access-to-e-mentoring-platform-program-body",
                  "translation": "Please enter the information for the person who will be the administrator of the e-mentoring platform for your program."
              },
              {
                  "source": "app-two-character-minimum",
                  "translation": "Please enter at least two characters."
              },
              {
                  "source": "app-responsiveness-tier",
                  "translation": "Responsiveness Tier"
              },
              {
                  "source": "app-ada",
                  "translation": "ADA"
              },
              {
                  "source": "app-nqms",
                  "translation": "NQMS"
              },
              {
                  "source": "app-program-delivery-community-based-description",
                  "translation": "Determine meeting times and locations based on preferences."
              },
              {
                  "source": "app-program-delivery-e-mentoring-description",
                  "translation": "Meet virtually through different platforms."
              },
              {
                  "source": "app-program-delivery-site-based-description",
                  "translation": "Meet at a consistent time and place - i.e. school, workplace, etc."
              },
              {
                  "source": "app-program-search-delivery-headline",
                  "translation": "What type of mentoring are you interested in?"
              },
              {
                  "source": "app-program-search-delivery-headline-description",
                  "translation": "Select all that interest you."
              },
              {
                  "source": "app-admin-add-affiliate",
                  "translation": "Add Affiliate"
              },
              {
                  "source": "app-grade-college",
                  "translation": "College"
              },
              {
                  "source": "app-search-callout",
                  "translation": "Mentoring amplifies change, one relationship at a time. Are you ready to join the mentoring movement?"
              },
              {
                  "source": "app-search-form-headline",
                  "translation": "Start here"
              },
              {
                  "source": "app-search-form-subheadline",
                  "translation": "Begin your path to mentorship&nbsp;&mdash; fill out the form below to see all the mentoring opportunities available near you!"
              },
              {
                  "source": "app-search-headline",
                  "translation": "How to become a"
              },
              {
                  "source": "app-search-sub-headline",
                  "translation": "mentor"
              },
              {
                  "source": "app-step",
                  "translation": "Step"
              },
              {
                  "source": "app-step1-headline",
                  "translation": "Fill Out the Form."
              },
              {
                  "source": "app-step1-sub-headline",
                  "translation": "Tell us about yourself, the type of mentoring you're interested in, and then click <span class='emphasis'>Search</span>."
              },
              {
                  "source": "app-step2-headline",
                  "translation": "Browse Opportunities."
              },
              {
                  "source": "app-step2-sub-headline",
                  "translation": "On the next page, browse a list of mentoring opportunities and find your favorite."
              },
              {
                  "source": "app-step3-headline",
                  "translation": "Get in Touch."
              },
              {
                  "source": "app-step3-sub-headline",
                  "translation": "Click the <span class='emphasis'>Contact Program</span> button to connect with the right program for you."
              },
              {
                  "source": "app-pyd-link",
                  "translation": "https://learn.pyd.org/mentoring/"
              },
              {
                  "source": "app-program-physical-address-line1",
                  "translation": "Address"
              },
              {
                  "source": "app-program-physical-address-line2",
                  "translation": "Address (line 2)"
              },
              {
                  "source": "app-program-physical-address-city",
                  "translation": "City"
              },
              {
                  "source": "app-program-physical-address-location",
                  "translation": "State"
              },
              {
                  "source": "app-program-physical-address-postal-code",
                  "translation": "Postal Code"
              },
              {
                  "source": "app-program-physical-address-country",
                  "translation": "Country"
              },
              {
                  "source": "app-program-delivery-address-helper-text",
                  "translation": "When adding your program delivery, you must include a numerical zip code (example, 02111) with your address. Zip codes are used to pull the correct mentoring programs for volunteers."
              },
              {
                  "source": "app-duplicate-program-name-error",
                  "translation": "A Program with the same name already exists in the Connector. Please log into <a href='https://portal.mentoring.org'>portal.mentoring.org</a> to view your Program or contact <a href='mailto:connector@mentoring.org'>connector@mentoring.org</a>."
              },
              {
                  "source": "app-duplicate-program-name-unknown-error",
                  "translation": "Error checking if program name is a duplicate."
              }
          ]
      };

      for(const row of stringResults.data) {
        this.strings.push(new LocalizedString(row))
      }
    }
  }

}
